export const types = {

  AUTH_CHEKING_FINISH_LOGIN_STATE: '[AUTH] CHEKING FINISH LOGIN STATE',
  
  AUTH_LOGIN: '[AUTH] LOGIN',
  AUTH_START_REGISTER: '[AUTH] START REGISTER',
  
  AUTH_START_TOKEN_RENEW: '[AUTH] START TOKEN RENEW',
  AUTH_LOGOUT: '[AUTH] LOGOUT',

  AUTH_SUCCESS_CONFIRMATION_REGISTER: '[AUTH] SUCCESS CONFIRMATION REGISTER',
  AUTH_FAILED_CONFIRMATION_REGISTER_ERROR: '[AUTH] FAILED CONFIRMATION REGISTER ERROR',
   AUTH_FAILED_CONFIRMATION_REGISTER_VALIDATION: '[AUTH] FAILED CONFIRMATION REGISTER VALIDATION',
   AUTH_CONFIRMATION_REGISTER_CLEAN: '[AUTH] CONFIRMATION REGISTER CLEAN',

   AUTH_SUCCESS_REGISTER: '[AUTH] SUCCESS REGISTER',
   AUTH_FAILED_REGISTER: '[AUTH] FAILED REGISTER',
   AUTH_CLEAN_REGISTER: '[AUTH] CLEAN REGISTER',

  USER_START_REGISTER_ADMIN: '[USER] START REGISTER_ADMIN',

  USER_START_LOADING: '[USER] START LOADING',
  USER_START_LOADING_PAGINATED: '[USER] START LOADING PAGINATED',
  USER_SELECT: '[USER] SELECT',
  USER_SELECT_FOR_PREFERENCES: '[USER] SELECT FOR PREFERENCES',
  USER_PREFERENCES_SET: '[USER] PREFERENCES SET',
  USER_START_SEARCH: '[USER] START SEARCH',
  USER_START_SEARCH_PAGINATED: '[USER] START SEARCH PAGINATED',
  USER_SELECT_IN_USER_ROLE: '[USER] SELECT IN USER ROLE',

  USER_START_REGISTER: '[USER] START REGISTER',
  USER_CLEAN_SAVED: '[USER] CLEAN SAVED',

  USER_UPDATE: '[USER] UPDATE',
  USER_UPDATE_FOR_PREFERENCES: '[USER] UPDATE FOR PREFERENCES',
  USER_DELETE: '[USER] DELETE',

  USER_SET_SEARCH_TEXT: '[USER] SET SEARCH TEXT',
  USER_CLEAN_SEARCH_TEXT: '[USER] CLEAN SEARCH TEXT',
  USER_CLEAN_USER_IN_USER_ROLE: '[USER] CLEAN USER IN USER ROLE',

  CONFIGURATION_START_LOADING: '[CONFIGURATION] START LOADING',
  CONFIGURATION_START_LOADING_BY_ID_FIELD: '[CONFIGURATION] START LOADING BY ID FIELD',
  CONFIGURATION_START_LOADING_PAGINATED: '[CONFIGURATION] START LOADING PAGINATED',
  CONFIGURATION_SELECT: '[CONFIGURATION] SELECT',
  CONFIGURATION_CLEAN_SEARCH_PAGINATED: '[CONFIGURATION] CLEAN SEARCH PAGINATED',
  CONFIGURATION_CLEAN: '[CONFIGURATION] CLEAN',
  CONFIGURATION_UPDATE: '[CONFIGURATION] UPDATE',
  CONFIGURATION_DELETE: '[CONFIGURATION] DELETE',
  CONFIGURATION_START_REGISTER: '[CONFIGURATION] START REGISTER',
  CONFIGURATION_START_SEARCH: '[CONFIGURATION] START SEARCH',
  CONFIGURATION_START_SEARCH_PAGINATED: '[CONFIGURATION] START SEARCH PAGINATED',
  CONFIGURATION_SET_SEARCH_TEXT: '[CONFIGURATION] SET SEARCH TEXT',
  CONFIGURATION_START_LOADING_ALL: '[CONFIGURATION] START LOADING ALL',


  USER_CLEAN_SEARCH_PAGINATED: '[USER] CLEAN SEARCH PAGINATED',
  USER_CLEAN: '[USER] CLEAN',

  USERROLE_LOGIN: '[USERROLE] LOGIN',
  USERROLE_SELECTED: '[USERROLE] SELECTED',
  USERROLE_SELECTED_CLEAN: '[USERROLE] SELECTED CLEAN',
  USERROLE_START_REGISTER_LIST: '[USERROLE] START REGISTER LIST',
  USERROLE_START_REGISTER_CLIENT: '[USERROLE] START REGISTER CLIENT',

  USERROLE_SELECTED_SPECIALIST: '[USERROLE] SELECTED SPECIALIST',

  USERROLEMODULE_GET_LIST_MODULES: '[USERROLEMODULE] GET LIST MODULES',
  USERROLEMODULE_START_REGISTER_LIST: '[USERROLEMODULE] START REGISTER LIST',

  GROUPCONCERN_START_REGISTER_LIST: '[GROUPCONCERN] START REGISTER LIST',

  MENU_GROUP_ROLE: '[MENU] GROUP ROLE',
  MENU_IS_LOADING_PATHS: '[MENU] IS LOADING PATHS',
  MENU_IS_RELOADING_FROM_URL: '[MENU] IS RELOADING FROM URL',
  MENU_PATH_FOR_COMPARE: '[MENU] PATH FOR COMPARE',

  MENU_START_LOADING: '[MENU] START LOADING',
  MENU_START_LOADING_PAGINATED: '[MENU] START LOADING PAGINATED',
  MENU_SELECT: '[MENU] SELECT',
  MENU_CLEAN_SEARCH_PAGINATED: '[MENU] CLEAN SEARCH PAGINATED',
  MENU_CLEAN: '[MENU] CLEAN',
  MENU_UPDATE: '[MENU] UPDATE',
  MENU_DELETE: '[MENU] DELETE',
  MENU_START_REGISTER: '[MENU] START REGISTER',
  MENU_START_SEARCH: '[MENU] START SEARCH',
  MENU_START_SEARCH_PAGINATED: '[MENU] START SEARCH PAGINATED',
  MENU_SET_SEARCH_TEXT: '[MENU] SET SEARCH TEXT',
  MENU_START_LOADING_ALL: '[MENU] START LOADING ALL',

  CATALOGROLE_START_LOADING: '[CATALOGROLE] START LOADING',
  CATALOGROLE_START_LOADING_PAGINATED: '[CATALOGROLE] START LOADING PAGINATED',
  CATALOGROLE_SELECT: '[CATALOGROLE] SELECT',
  CATALOGROLE_CLEAN_SEARCH_PAGINATED: '[CATALOGROLE] CLEAN SEARCH PAGINATED',
  CATALOGROLE_CLEAN: '[CATALOGROLE] CLEAN',
  CATALOGROLE_UPDATE: '[CATALOGROLE] UPDATE',
  CATALOGROLE_DELETE: '[CATALOGROLE] DELETE',
  CATALOGROLE_START_REGISTER: '[CATALOGROLE] START REGISTER',
  CATALOGROLE_START_SEARCH: '[CATALOGROLE] START SEARCH',
  CATALOGROLE_START_SEARCH_PAGINATED: '[CATALOGROLE] START SEARCH PAGINATED',
  CATALOGROLE_SET_SEARCH_TEXT: '[CATALOGROLE] SET SEARCH TEXT',

  CATALOGMODULE_START_LOADING: '[CATALOGMODULE] START LOADING',
  CATALOGMODULE_START_LOADING_PAGINATED: '[CATALOGMODULE] START LOADING PAGINATED',
  CATALOGMODULE_SELECT: '[CATALOGMODULE] SELECT',
  CATALOGMODULE_CLEAN_SEARCH_PAGINATED: '[CATALOGMODULE] CLEAN SEARCH PAGINATED',
  CATALOGMODULE_CLEAN: '[CATALOGMODULE] CLEAN',
  CATALOGMODULE_UPDATE: '[CATALOGMODULE] UPDATE',
  CATALOGMODULE_DELETE: '[CATALOGMODULE] DELETE',
  CATALOGMODULE_START_REGISTER: '[CATALOGMODULE] START REGISTER',
  CATALOGMODULE_START_SEARCH: '[CATALOGMODULE] START SEARCH',
  CATALOGMODULE_START_SEARCH_PAGINATED: '[CATALOGMODULE] START SEARCH PAGINATED',
  CATALOGMODULE_SET_SEARCH_TEXT: '[CATALOGMODULE] SET SEARCH TEXT',

  RULEFLOW_START_LOADING: '[RULEFLOW] START LOADING',
  RULEFLOW_BY_MODULE_START_LOADING: '[RULEFLOW] BY MODULE START LOADING',

  ROLEFLOW_START_REGISTER: '[ROLEFLOW] START REGISTER',
  ROLEFLOW_START_LOADING: '[ROLEFLOW] START LOADING',
  ROLEFLOW_SET_TIMELINE: '[ROLEFLOW] SET TIMELINE',
  ROLEFLOW_SET_LOADING: '[ROLEFLOW] SET LOADING',

  FLOWENGINE_SET_LOADING: '[FLOWENGINE] SET LOADING',
  FLOWENGINE_SET_CATALOGS: '[FLOWENGINE] SET CATALOGS',
  FLOWENGINE_SET_INBOX_LOADING: '[FLOWENGINE] SET INBOX LOADING',
  FLOWENGINE_SET_INBOX: '[FLOWENGINE] SET INBOX',

  FLOW_START_LOADING: '[FLOW] START LOADING',
  FLOW_START_LOADING_FULL_MODULE: '[FLOW] START LOADING FULL MODULE',

  FLOW_ROLE_CIIU_ASSIGNMENT_START_LOADING: '[FLOW_ROLE_CIIU_ASSIGNMENT] START LOADING',
  FLOW_ROLE_CIIU_ASSIGNMENT_SET: '[FLOW_ROLE_CIIU_ASSIGNMENT] SET',

  FLOW_MODULE_CONFIG_START_LOADING: '[FLOW_MODULE_CONFIG] START LOADING',
  FLOW_MODULE_CONFIG_SET_MANAGERS: '[FLOW_MODULE_CONFIG] SET MANAGERS',
  FLOW_MODULE_CONFIG_SET_VALIDATORS: '[FLOW_MODULE_CONFIG] SET VALIDATORS',
  FLOW_MODULE_CONFIG_SET_EDITORS: '[FLOW_MODULE_CONFIG] SET EDITORS',
  FLOW_CHECKLIST_SET_LOADING: '[FLOW_CHECKLIST] SET LOADING',
  FLOW_CHECKLIST_SET_DEFS: '[FLOW_CHECKLIST] SET DEFS',
  FLOW_CHECKLIST_SET_RECORD: '[FLOW_CHECKLIST] SET RECORD',
  FLOW_ASSIGNMENT_POLICY_SET_LOADING: '[FLOW_ASSIGNMENT_POLICY] SET LOADING',
  FLOW_ASSIGNMENT_POLICY_SET_LIST: '[FLOW_ASSIGNMENT_POLICY] SET LIST',
  FLOW_COVERAGE_SET_LOADING: '[FLOW_COVERAGE] SET LOADING',
  FLOW_COVERAGE_SET: '[FLOW_COVERAGE] SET',
  FLOW_COVERAGE_PATCH_MEMBER: '[FLOW_COVERAGE] PATCH MEMBER',
  FLOW_CMI_SET_LOADING: '[FLOW_CMI] SET LOADING',
  FLOW_CMI_SET_DASHBOARD: '[FLOW_CMI] SET DASHBOARD',
  FLOW_CMI_SET_CASES: '[FLOW_CMI] SET CASES',
  FLOW_CMI_SET_DETAIL: '[FLOW_CMI] SET DETAIL',
  FLOW_CMI_CLEAR_DETAIL: '[FLOW_CMI] CLEAR DETAIL',

  FLOW_REASSIGNMENT_START_LOADING: '[FLOW_REASSIGNMENT] START LOADING',
  FLOW_REASSIGNMENT_SET_PREVIEW: '[FLOW_REASSIGNMENT] SET PREVIEW',
  FLOW_REASSIGNMENT_SET_EXECUTE_RESULT: '[FLOW_REASSIGNMENT] SET EXECUTE RESULT',
  FLOW_REASSIGNMENT_CLEAR: '[FLOW_REASSIGNMENT] CLEAR',

  FLOW_LIST_FILTER_SET_ASSIGNED_ONLY: '[FLOW_LIST_FILTER] SET ASSIGNED ONLY',
  FLOW_LIST_FILTER_SET_SHOW_PENDING: '[FLOW_LIST_FILTER] SET SHOW PENDING',
  FLOW_LIST_FILTER_SET_SHOW_REJECTED: '[FLOW_LIST_FILTER] SET SHOW REJECTED',
  FLOW_LIST_FILTER_SET_EXTRA: '[FLOW_LIST_FILTER] SET EXTRA',
  FLOW_LIST_FILTER_SET_TRAY_VIEW: '[FLOW_LIST_FILTER] SET TRAY VIEW',

  SPECIALIST_SELECTION_SET_ROLES_LOADING: '[SPECIALIST_SELECTION] SET ROLES LOADING',
  SPECIALIST_SELECTION_SET_ROLES: '[SPECIALIST_SELECTION] SET ROLES',
  SPECIALIST_SELECTION_SET_POOL_LOADING: '[SPECIALIST_SELECTION] SET POOL LOADING',
  SPECIALIST_SELECTION_SET_POOL: '[SPECIALIST_SELECTION] SET POOL',
  SPECIALIST_SELECTION_SET_ASSIGNED_LOADING: '[SPECIALIST_SELECTION] SET ASSIGNED LOADING',
  SPECIALIST_SELECTION_SET_ASSIGNED: '[SPECIALIST_SELECTION] SET ASSIGNED',
  SPECIALIST_SELECTION_SET_ACTION_LOADING: '[SPECIALIST_SELECTION] SET ACTION LOADING',
  SPECIALIST_SELECTION_SET_ERROR: '[SPECIALIST_SELECTION] SET ERROR',
  SPECIALIST_SELECTION_SET_METRICS_LOADING: '[SPECIALIST_SELECTION] SET METRICS LOADING',
  SPECIALIST_SELECTION_SET_METRICS: '[SPECIALIST_SELECTION] SET METRICS',

  FILE_START_LOADING: '[FILE] START LOADING',
  FILE_START_LOADING_BY_USER_ID: '[FILE] START LOADING BY USER ID',
  FILE_START_LOADING_PAGINATED: '[FILE] START LOADING PAGINATED',
  FILE_SELECT: '[FILE] SELECT',
  FILE_CLEAN_SEARCH_PAGINATED: '[FILE] CLEAN SEARCH PAGINATED',
  FILE_CLEAN: '[FILE] CLEAN',
  FILE_UPDATE: '[FILE] UPDATE',
  FILE_DELETE: '[FILE] DELETE',
  FILE_START_REGISTER: '[FILE] START REGISTER',
  FILE_START_SEARCH: '[FILE] START SEARCH',
  FILE_START_SEARCH_PAGINATED: '[FILE] START SEARCH PAGINATED',
  FILE_SET_SEARCH_TEXT: '[FILE] SET SEARCH TEXT',

  IMPORT_DATA_TECHNOLOGY: '[IMPORT_DATA] TECHNOLOGY',
  IMPORT_DATA_TECHNOLOGY_LOCAL_PAGINATION: '[IMPORT_DATA] TECHNOLOGY LOCAL PAGINATION',
  IMPORT_DATA_TECHNOLOGY_LOADING: '[IMPORT_DATA] TECHNOLOGY LOADING',
  IMPORT_DATA_TECHNOLOGY_FINISH: '[IMPORT_DATA] TECHNOLOGY FINISH',

  IMPORT_DATA_TECHNOLOGY_CLEAN: '[IMPORT_DATA] TECHNOLOGY CLEAN',
  DOWNLOAD_DATA_TECHNOLOGY: '[DOWNLOAD_DATA] TECHNOLOGY',
  DOWNLOAD_EXAMPLE_DATA_TECHNOLOGY: '[DOWNLOAD_EXAMPLE_DATA] TECHNOLOGY',
  
  IMPORT_DATA_ALTERNATIVE: '[IMPORT_DATA] ALTERNATIVE',
  IMPORT_DATA_ALTERNATIVE_LOCAL_PAGINATION: '[IMPORT_DATA] ALTERNATIVE LOCAL PAGINATION',
  IMPORT_DATA_ALTERNATIVE_LOADING: '[IMPORT_DATA] ALTERNATIVE LOADING',
  IMPORT_DATA_ALTERNATIVE_FINISH: '[IMPORT_DATA] ALTERNATIVE FINISH',

  IMPORT_DATA_ALTERNATIVE_CLEAN: '[IMPORT_DATA] ALTERNATIVE CLEAN',
  DOWNLOAD_DATA_ALTERNATIVE: '[DOWNLOAD_DATA] ALTERNATIVE',
  DOWNLOAD_EXAMPLE_DATA_ALTERNATIVE: '[DOWNLOAD_EXAMPLE_DATA] ALTERNATIVE',
  
  IMPORT_DATA_EXPERIENCE: '[IMPORT_DATA] EXPERIENCE',
  IMPORT_DATA_EXPERIENCE_LOCAL_PAGINATION: '[IMPORT_DATA] EXPERIENCE LOCAL PAGINATION',
  IMPORT_DATA_EXPERIENCE_LOADING: '[IMPORT_DATA] EXPERIENCE LOADING',
  IMPORT_DATA_EXPERIENCE_FINISH: '[IMPORT_DATA] EXPERIENCE FINISH',

  IMPORT_DATA_EXPERIENCE_CLEAN: '[IMPORT_DATA] EXPERIENCE CLEAN',
  DOWNLOAD_DATA_EXPERIENCE: '[DOWNLOAD_DATA] EXPERIENCE',
  DOWNLOAD_EXAMPLE_DATA_EXPERIENCE: '[DOWNLOAD_EXAMPLE_DATA] EXPERIENCE',
  
  IMPORT_DATA_INNOVATION: '[IMPORT_DATA] INNOVATION',
  IMPORT_DATA_INNOVATION_LOCAL_PAGINATION: '[IMPORT_DATA] INNOVATION LOCAL PAGINATION',
  IMPORT_DATA_INNOVATION_LOADING: '[IMPORT_DATA] INNOVATION LOADING',
  IMPORT_DATA_INNOVATION_FINISH: '[IMPORT_DATA] INNOVATION FINISH',

  IMPORT_DATA_INNOVATION_CLEAN: '[IMPORT_DATA] INNOVATION CLEAN',
  DOWNLOAD_DATA_INNOVATION: '[DOWNLOAD_DATA] INNOVATION',
  DOWNLOAD_EXAMPLE_DATA_INNOVATION: '[DOWNLOAD_EXAMPLE_DATA] INNOVATION',
  
  IMPORT_DATA_ASSISTANCE: '[IMPORT_DATA] ASSISTANCE',
  IMPORT_DATA_ASSISTANCE_LOCAL_PAGINATION: '[IMPORT_DATA] ASSISTANCE LOCAL PAGINATION',
  IMPORT_DATA_ASSISTANCE_LOADING: '[IMPORT_DATA] ASSISTANCE LOADING',
  IMPORT_DATA_ASSISTANCE_FINISH: '[IMPORT_DATA] ASSISTANCE FINISH',

  IMPORT_DATA_ASSISTANCE_CLEAN: '[IMPORT_DATA] ASSISTANCE CLEAN',
  DOWNLOAD_DATA_ASSISTANCE: '[DOWNLOAD_DATA] ASSISTANCE',
  DOWNLOAD_EXAMPLE_DATA_ASSISTANCE: '[DOWNLOAD_EXAMPLE_DATA] ASSISTANCE',
  
  IMPORT_DATA_FINANCIAL: '[IMPORT_DATA] FINANCIAL',
  IMPORT_DATA_FINANCIAL_LOCAL_PAGINATION: '[IMPORT_DATA] FINANCIAL LOCAL PAGINATION',
  IMPORT_DATA_FINANCIAL_LOADING: '[IMPORT_DATA] FINANCIAL LOADING',
  IMPORT_DATA_FINANCIAL_FINISH: '[IMPORT_DATA] FINANCIAL FINISH',

  IMPORT_DATA_FINANCIAL_CLEAN: '[IMPORT_DATA] FINANCIAL CLEAN',
  DOWNLOAD_DATA_FINANCIAL: '[DOWNLOAD_DATA] FINANCIAL',
  DOWNLOAD_EXAMPLE_DATA_FINANCIAL: '[DOWNLOAD_EXAMPLE_DATA] FINANCIAL',
  
  IMPORT_DATA_REGULATION: '[IMPORT_DATA] REGULATION',
  IMPORT_DATA_REGULATION_LOCAL_PAGINATION: '[IMPORT_DATA] REGULATION LOCAL PAGINATION',
  IMPORT_DATA_REGULATION_LOADING: '[IMPORT_DATA] REGULATION LOADING',
  IMPORT_DATA_REGULATION_FINISH: '[IMPORT_DATA] REGULATION FINISH',

  IMPORT_DATA_REGULATION_CLEAN: '[IMPORT_DATA] REGULATION CLEAN',
  DOWNLOAD_DATA_REGULATION: '[DOWNLOAD_DATA] REGULATION',
  DOWNLOAD_EXAMPLE_DATA_REGULATION: '[DOWNLOAD_EXAMPLE_DATA] REGULATION',
  
  IMPORT_DATA_VISION: '[IMPORT_DATA] VISION',
  IMPORT_DATA_VISION_LOCAL_PAGINATION: '[IMPORT_DATA] VISION LOCAL PAGINATION',
  IMPORT_DATA_VISION_LOADING: '[IMPORT_DATA] VISION LOADING',
  IMPORT_DATA_VISION_FINISH: '[IMPORT_DATA] VISION FINISH',

  IMPORT_DATA_VISION_CLEAN: '[IMPORT_DATA] VISION CLEAN',
  DOWNLOAD_DATA_VISION: '[DOWNLOAD_DATA] VISION',
  DOWNLOAD_EXAMPLE_DATA_VISION: '[DOWNLOAD_EXAMPLE_DATA] VISION',

  TECHNOLOGY_FILE_START_LOADING_BY_TECHNOLOGY_ID: '[TECHNOLOGY FILE] START LOADING BY TECHNOLOGY ID',

  ALTERNATIVE_TECHNOLOGY_FILE_START_LOADING_BY_ALTERNATIVE_TECHNOLOGY_ID: '[ALTERNATIVE TECHNOLOGY FILE] START LOADING BY ALTERNATIVE TECHNOLOGY ID',

  TRACKING_START_REGISTER: '[TRACKING] START REGISTER',

  SUGGEST_CASE_SUCCESS_REGISTER: '[SUGGEST_CASE] SUCCESS REGISTER',
  SUGGEST_CASE_ERROR_REGISTER: '[SUGGEST_CASE] ERROR REGISTER',
  SUGGEST_CASE_START_LOADING_PAGINATED: '[SUGGEST_CASE] START LOADING PAGINATED',
  SUGGEST_CASE_CLEAN: '[SUGGEST_CASE] CLEAN',
  SUGGEST_CASE_START_LOADING: '[SUGGEST_CASE] START LOADING',
  SUGGEST_CASE_STOP_LOADING: '[SUGGEST_CASE] STOP LOADING',

  SEARCH_INFO_START_REGISTER: '[SEARCH_INFO] START REGISTER',
  SEARCH_RESULT_START_REGISTER: '[SEARCH_RESULT] START REGISTER',
  COMPARE_RESULT_START_REGISTER: '[COMPARE_RESULT] START REGISTER',

  STATISTICS_ADMINISTRATION_LOADING: '[STATISTICS] ADMINISTRATION LOADING',
  STATISTICS_SPECIALIST_LOADING: '[STATISTICS] SPECIALIST LOADING',
  STATISTICS_END_USER_LOADING: '[STATISTICS] END_USER LOADING',

  STATISTICS_END_USER_SEARCH_INFO_TEXT_MODULE: '[STATISTICS] END_USER SEARCH_INFO TEXT MODULE',
  STATISTICS_END_USER_SEARCH_INFO_INDICATORS_MODULE: '[STATISTICS] END_USER SEARCH_INFO INDICATORS MODULE',
  STATISTICS_END_USER_SEARCH_INFO_FILTERS_MODULE: '[STATISTICS] END_USER SEARCH_INFO_FILTERS MODULE',
  STATISTICS_END_USER_SEARCH_RESULT_REPETITIONS_MODULE: '[STATISTICS] END_USER SEARCH_RESULT REPETITIONS MODULE',
  STATISTICS_END_USER_SEARCH_RESULT_LESS30_MODULE: '[STATISTICS] END_USER SEARCH_RESULT_LESS30 MODULE',
  STATISTICS_END_USER_COMPARE_RESULT_FIELDS_MODULE: '[STATISTICS] END_USER COMPARE_RESULT FIELDS MODULE',
  STATISTICS_END_USER_COMPARE_RESULT_REPETITION_MODULE: '[STATISTICS] END_USER COMPARE_RESULT REPETITION_MODULE',
  STATISTIC_END_USER_CLEAN_STATS: '[STATISTICS] END_USER CLEAN STATS',
  STATISTICS_INTENTIONS_LOADING: '[STATISTICS] INTENTIONS LOADING',
  STATISTICS_INTENTIONS_SET_LOADING: '[STATISTICS] INTENTIONS SET LOADING',
  STATISTICS_HEALTH_LOADING: '[STATISTICS] HEALTH LOADING',
  STATISTICS_FLOW_ENGINE_LOADING: '[STATISTICS] FLOW ENGINE LOADING',
  STATISTICS_JOURNEY_LOADING: '[STATISTICS] JOURNEY LOADING',
  STATISTICS_TRENDS_LOADING: '[STATISTICS] TRENDS LOADING',
  STATISTICS_EXPLORE_LOADING: '[STATISTICS] EXPLORE LOADING',
  STATISTICS_END_USER_ACTIVITY_LOADING: '[STATISTICS] END_USER ACTIVITY LOADING',

  CATALOG_START_LOADING: '[CATALOG] START LOADING',
  CATALOG_START_LOADING_SERIES: '[CATALOG] START LOADING SERIES',
  CATALOG_START_LOADING_BY_GROUP_VISION: '[CATALOG] START LOADING BY GROUP VISION',
  CATALOG_CLEAN_CONCERN_BY_GROUP_VISION: '[CATALOG] CLEAN CONCERN BY GROUP VISION',
  CATALOG_SET_TOPIC_QUESTION_LISTS: '[CATALOG] SET TOPIC QUESTION LISTS',

  CATALOG_START_LOADING_SOPHISTICATIONS: '[CATALOG] START LOADING SOPHISTICATIONS',
  CATALOG_START_LOADING_AMPLITUDES: '[CATALOG] START LOADING AMPLITUDES',
  CATALOG_START_LOADING_SIZES: '[CATALOG] START LOADING SIZES',
  CATALOG_START_LOADING_SCIENTIFICS: '[CATALOG] START LOADING SCIENTIFICS',
  CATALOG_START_LOADING_MITIGATIONS: '[CATALOG] START LOADING MITIGATIONS',
  CATALOG_START_LOADING_ADAPTATIONS: '[CATALOG] START LOADING ADAPTATIONS',
  CATALOG_START_LOADING_PRODUCTIONS: '[CATALOG] START LOADING PRODUCTIONS',
  CATALOG_START_LOADING_SERVICES: '[CATALOG] START LOADING SERVICES',

  CATALOG_START_LOADING_FENOMENO: '[CATALOG] START LOADING FENOMENO',
  CATALOG_START_LOADING_TECHNOLOGY_TYPES: '[CATALOG] START LOADING TECHNOLOGY TYPES',
  CATALOG_START_LOADING_MULTIMEDIA: '[CATALOG] START LOADING MULTIMEDIA',
  CATALOG_START_LOADING_FENOMENO_CATEGORIA: '[CATALOG] START LOADING FENOMENO CATEGORIA',
  CATALOG_START_LOADING_TAMANIO_SISTEMA: '[CATALOG] START LOADING TAMANIOS SISTEMA',

  CATALOG_START_LOADING_AMBITO_APLICACION: '[CATALOG] START LOADING AMBITO APLICACION',
  CATALOG_START_LOADING_ALCANCE_TIPO: '[CATALOG] START LOADING ALCANCE TIPO',
  CATALOG_START_LOADING_MODULO_BUSQUEDA_TIPO: '[CATALOG] START LOADING MODULO BUSQUEDA TIPO',
  CATALOG_START_LOADING_ESFUERZO_TIPO: '[CATALOG] START LOADING ESFUERZO TIPO',
  CATALOG_START_LOADING_PRODUCCION_TIPO: '[CATALOG] START LOADING PRODUCCION TIPO',
  CATALOG_START_LOADING_AMBITO_REGULACION: '[CATALOG] START LOADING AMBITO REGULACION',

  CATALOG_START_LOADING_ENFOQUE_ESTRATEGIA: '[CATALOG] START LOADING ENFOQUE ESTRATEGIA',
  CATALOG_START_LOADING_ENFOQUE_MEDIDA: '[CATALOG] START LOADING ENFOQUE MEDIDA',

  CATALOG_START_LOADING_ALL: '[CATALOG] START LOADING ALL',
  CATALOG_START_LOADING_FILTER: '[CATALOG] START LOADING FILTER',

  CATALOG_START_LOADING_PAGINATED: '[CATALOG] START LOADING PAGINATED',
  CATALOG_SELECT: '[CATALOG] SELECT',
  CATALOG_CLEAN_SEARCH_PAGINATED: '[CATALOG] CLEAN SEARCH PAGINATED',
  CATALOG_CLEAN: '[CATALOG] CLEAN',
  CATALOG_UPDATE: '[CATALOG] UPDATE',
  CATALOG_DELETE: '[CATALOG] DELETE',
  CATALOG_START_REGISTER: '[CATALOG] START REGISTER',
  CATALOG_START_SEARCH: '[CATALOG] START SEARCH',
  CATALOG_START_SEARCH_PAGINATED: '[CATALOG] START SEARCH PAGINATED',
  CATALOG_SET_SEARCH_TEXT: '[CATALOG] SET SEARCH TEXT',

  CATALOG_TYPE_START_LOADING: '[CATALOG_TYPE] START LOADING',
  
  CATALOG_TYPE_START_LOADING_PAGINATED: '[CATALOG_TYPE] START LOADING PAGINATED',
  CATALOG_TYPE_SELECT: '[CATALOG_TYPE] SELECT',
  CATALOG_TYPE_CLEAN_SEARCH_PAGINATED: '[CATALOG_TYPE] CLEAN SEARCH PAGINATED',
  CATALOG_TYPE_CLEAN: '[CATALOG_TYPE] CLEAN',
  CATALOG_TYPE_UPDATE: '[CATALOG_TYPE] UPDATE',
  CATALOG_TYPE_DELETE: '[CATALOG_TYPE] DELETE',
  CATALOG_TYPE_START_REGISTER: '[CATALOG_TYPE] START REGISTER',
  CATALOG_TYPE_START_SEARCH: '[CATALOG_TYPE] START SEARCH',
  CATALOG_TYPE_START_SEARCH_PAGINATED: '[CATALOG_TYPE] START SEARCH PAGINATED',
  CATALOG_TYPE_SET_SEARCH_TEXT: '[CATALOG_TYPE] SET SEARCH TEXT',

  CATALOG_TYPE_START_LOADING_ALL: '[CATALOG_TYPE] START LOADING ALL',

  CATALOGCIIU_START_LOADING: '[CATALOGCIIU] START LOADING',
  CATALOGCIIU_START_LOADING_LEVEL1: '[CATALOGCIIU] START LOADING LEVEL1',
  CATALOGCIIU_START_LOADING_LEVEL2: '[CATALOGCIIU] START LOADING LEVEL2',
  CATALOGCIIU_START_LOADING_LEVEL3: '[CATALOGCIIU] START LOADING LEVEL3',
  CATALOGCIIU_START_LOADING_LEVEL4: '[CATALOGCIIU] START LOADING LEVEL4',
  CATALOGCIIU_START_LOADING_LEVEL5: '[CATALOGCIIU] START LOADING LEVEL5',
  CATALOGCIIU_START_LOADING_LEVEL6: '[CATALOGCIIU] START LOADING LEVEL6',
  CATALOGCIIU_START_LOADING_ALL_LEVEL6: '[CATALOGCIIU] START LOADING ALL LEVEL6',
  CATALOGCIIU_SELECT_LEVEL1: '[CATALOGCIIU] SELECT LEVEL1',
  CATALOGCIIU_SELECT_LEVEL2: '[CATALOGCIIU] SELECT LEVEL2',
  CATALOGCIIU_SELECT_LEVEL3: '[CATALOGCIIU] SELECT LEVEL3',
  CATALOGCIIU_SELECT_LEVEL4: '[CATALOGCIIU] SELECT LEVEL4',
  CATALOGCIIU_SELECT_LEVEL5: '[CATALOGCIIU] SELECT LEVEL5',
  CATALOGCIIU_SELECT_LEVEL6: '[CATALOGCIIU] SELECT LEVEL6',
  CATALOGCIIU_CLEAN_LEVEL1: '[CATALOGCIIU] CLEAN LEVEL1',
  CATALOGCIIU_CLEAN_LEVEL2: '[CATALOGCIIU] CLEAN LEVEL2',
  CATALOGCIIU_CLEAN_LEVEL3: '[CATALOGCIIU] CLEAN LEVEL3',
  CATALOGCIIU_CLEAN_LEVEL4: '[CATALOGCIIU] CLEAN LEVEL4',
  CATALOGCIIU_CLEAN_LEVEL5: '[CATALOGCIIU] CLEAN LEVEL5',
  CATALOGCIIU_CLEAN_LEVEL6: '[CATALOGCIIU] CLEAN LEVEL6',

  CATALOGCIIU_START_LOADING_ALL: '[CATALOGCIIU] START LOADING ALL',
  CATALOGCIIU_START_LOADING_NO_LEVEL6: '[CATALOGCIIU] START LOADING NO_LEVEL6',

  CATALOGCIIU_START_LOADING_FILTER: '[CATALOGCIIU] START LOADING FILTER',

  /*
  CATALOGCIIU_CLEAN_LIST_LEVEL1 : '[CATALOGCIIU] CLEAN LIST LEVEL1',
  CATALOGCIIU_CLEAN_LIST_LEVEL2 : '[CATALOGCIIU] CLEAN LIST LEVEL2',
  CATALOGCIIU_CLEAN_LIST_LEVEL3 : '[CATALOGCIIU] CLEAN LIST LEVEL3',
  CATALOGCIIU_CLEAN_LIST_LEVEL4 : '[CATALOGCIIU] CLEAN LIST LEVEL4',
  CATALOGCIIU_CLEAN_LIST_LEVEL5 : '[CATALOGCIIU] CLEAN LIST LEVEL5',
  CATALOGCIIU_CLEAN_LIST_LEVEL6 : '[CATALOGCIIU] CLEAN LIST LEVEL6',
  CATALOGCIIU_CLEAN_SELECT_LEVEL1 : '[CATALOGCIIU] CLEAN SELECT LEVEL1',
  CATALOGCIIU_CLEAN_SELECT_LEVEL2 : '[CATALOGCIIU] CLEAN SELECT LEVEL2',
  CATALOGCIIU_CLEAN_SELECT_LEVEL3 : '[CATALOGCIIU] CLEAN SELECT LEVEL3',
  CATALOGCIIU_CLEAN_SELECT_LEVEL4 : '[CATALOGCIIU] CLEAN SELECT LEVEL4',
  CATALOGCIIU_CLEAN_SELECT_LEVEL5 : '[CATALOGCIIU] CLEAN SELECT LEVEL5',
  CATALOGCIIU_CLEAN_SELECT_LEVEL6 : '[CATALOGCIIU] CLEAN SELECT LEVEL6',
 */

  CATALOGCIIU_START_LOADING_PAGINATED: '[CATALOGCIIU] START LOADING PAGINATED',
  CATALOGCIIU_SELECT: '[CATALOGCIIU] SELECT',
  CATALOGCIIU_CLEAN_SEARCH_PAGINATED: '[CATALOGCIIU] CLEAN SEARCH PAGINATED',
  CATALOGCIIU_CLEAN: '[CATALOGCIIU] CLEAN',
  CATALOGCIIU_UPDATE: '[CATALOGCIIU] UPDATE',
  CATALOGCIIU_DELETE: '[CATALOGCIIU] DELETE',
  CATALOGCIIU_START_REGISTER: '[CATALOGCIIU] START REGISTER',
  CATALOGCIIU_START_SEARCH: '[CATALOGCIIU] START SEARCH',
  CATALOGCIIU_START_SEARCH_PAGINATED: '[CATALOGCIIU] START SEARCH PAGINATED',
  CATALOGCIIU_SET_SEARCH_TEXT: '[CATALOGCIIU] SET SEARCH TEXT',

  CATALOGSECTION_START_LOADING: '[CATALOGSECTION] START LOADING',
  CATALOGSECTION_START_LOADING_LEVEL1: '[CATALOGSECTION] START LOADING LEVEL1',
  CATALOGSECTION_START_LOADING_LEVEL2: '[CATALOGSECTION] START LOADING LEVEL2',
  CATALOGSECTION_START_LOADING_LEVEL3: '[CATALOGSECTION] START LOADING LEVEL3',
  CATALOGSECTION_START_LOADING_LEVEL4: '[CATALOGSECTION] START LOADING LEVEL4',
  CATALOGSECTION_START_LOADING_LEVEL5: '[CATALOGSECTION] START LOADING LEVEL5',
  CATALOGSECTION_START_LOADING_LEVEL6: '[CATALOGSECTION] START LOADING LEVEL6',
  CATALOGSECTION_START_LOADING_ALL_LEVEL6: '[CATALOGSECTION] START LOADING ALL LEVEL6',
  CATALOGSECTION_SELECT_LEVEL1: '[CATALOGSECTION] SELECT LEVEL1',
  CATALOGSECTION_SELECT_LEVEL2: '[CATALOGSECTION] SELECT LEVEL2',
  CATALOGSECTION_SELECT_LEVEL3: '[CATALOGSECTION] SELECT LEVEL3',
  CATALOGSECTION_SELECT_LEVEL4: '[CATALOGSECTION] SELECT LEVEL4',
  CATALOGSECTION_SELECT_LEVEL5: '[CATALOGSECTION] SELECT LEVEL5',
  CATALOGSECTION_SELECT_LEVEL6: '[CATALOGSECTION] SELECT LEVEL6',
  CATALOGSECTION_CLEAN_LEVEL1: '[CATALOGSECTION] CLEAN LEVEL1',
  CATALOGSECTION_CLEAN_LEVEL2: '[CATALOGSECTION] CLEAN LEVEL2',
  CATALOGSECTION_CLEAN_LEVEL3: '[CATALOGSECTION] CLEAN LEVEL3',
  CATALOGSECTION_CLEAN_LEVEL4: '[CATALOGSECTION] CLEAN LEVEL4',
  CATALOGSECTION_CLEAN_LEVEL5: '[CATALOGSECTION] CLEAN LEVEL5',
  CATALOGSECTION_CLEAN_LEVEL6: '[CATALOGSECTION] CLEAN LEVEL6',

  CATALOGSECTION_START_LOADING_ALL: '[CATALOGSECTION] START LOADING ALL',

  CATALOGSECTION_START_LOADING_NO_LEVEL6: '[CATALOGSECTION] START LOADING NO_LEVEL6',
  CATALOGSECTION_START_LOADING_FILTER: '[CATALOGSECTION] START LOADING FILTER',

  /*
  CATALOGSECTION_CLEAN_LIST_LEVEL1 : '[CATALOGSECTION] CLEAN LIST LEVEL1',
  CATALOGSECTION_CLEAN_LIST_LEVEL2 : '[CATALOGSECTION] CLEAN LIST LEVEL2',
  CATALOGSECTION_CLEAN_LIST_LEVEL3 : '[CATALOGSECTION] CLEAN LIST LEVEL3',
  CATALOGSECTION_CLEAN_LIST_LEVEL4 : '[CATALOGSECTION] CLEAN LIST LEVEL4',
  CATALOGSECTION_CLEAN_LIST_LEVEL5 : '[CATALOGSECTION] CLEAN LIST LEVEL5',
  CATALOGSECTION_CLEAN_LIST_LEVEL6 : '[CATALOGSECTION] CLEAN LIST LEVEL6',
  CATALOGSECTION_CLEAN_SELECT_LEVEL1 : '[CATALOGSECTION] CLEAN SELECT LEVEL1',
  CATALOGSECTION_CLEAN_SELECT_LEVEL2 : '[CATALOGSECTION] CLEAN SELECT LEVEL2',
  CATALOGSECTION_CLEAN_SELECT_LEVEL3 : '[CATALOGSECTION] CLEAN SELECT LEVEL3',
  CATALOGSECTION_CLEAN_SELECT_LEVEL4 : '[CATALOGSECTION] CLEAN SELECT LEVEL4',
  CATALOGSECTION_CLEAN_SELECT_LEVEL5 : '[CATALOGSECTION] CLEAN SELECT LEVEL5',
  CATALOGSECTION_CLEAN_SELECT_LEVEL6 : '[CATALOGSECTION] CLEAN SELECT LEVEL6',
 */

  CATALOGSECTION_START_LOADING_PAGINATED: '[CATALOGSECTION] START LOADING PAGINATED',
  CATALOGSECTION_SELECT: '[CATALOGSECTION] SELECT',
  CATALOGSECTION_CLEAN_SEARCH_PAGINATED: '[CATALOGSECTION] CLEAN SEARCH PAGINATED',
  CATALOGSECTION_CLEAN: '[CATALOGSECTION] CLEAN',
  CATALOGSECTION_UPDATE: '[CATALOGSECTION] UPDATE',
  CATALOGSECTION_DELETE: '[CATALOGSECTION] DELETE',
  CATALOGSECTION_START_REGISTER: '[CATALOGSECTION] START REGISTER',
  CATALOGSECTION_START_SEARCH: '[CATALOGSECTION] START SEARCH',
  CATALOGSECTION_START_SEARCH_PAGINATED: '[CATALOGSECTION] START SEARCH PAGINATED',
  CATALOGSECTION_SET_SEARCH_TEXT: '[CATALOGSECTION] SET SEARCH TEXT',

  CATALOGPHASE_START_LOADING: '[CATALOGPHASE] START LOADING',
  CATALOGPHASE_START_LOADING_LEVEL1: '[CATALOGPHASE] START LOADING LEVEL1',
  CATALOGPHASE_START_LOADING_LEVEL2: '[CATALOGPHASE] START LOADING LEVEL2',
  CATALOGPHASE_START_LOADING_LEVEL3: '[CATALOGPHASE] START LOADING LEVEL3',
  CATALOGPHASE_START_LOADING_LEVEL4: '[CATALOGPHASE] START LOADING LEVEL4',
  CATALOGPHASE_START_LOADING_LEVEL5: '[CATALOGPHASE] START LOADING LEVEL5',
  CATALOGPHASE_START_LOADING_LEVEL6: '[CATALOGPHASE] START LOADING LEVEL6',
  CATALOGPHASE_START_LOADING_ALL_LEVEL6: '[CATALOGPHASE] START LOADING ALL LEVEL6',
  CATALOGPHASE_SELECT_LEVEL1: '[CATALOGPHASE] SELECT LEVEL1',
  CATALOGPHASE_SELECT_LEVEL2: '[CATALOGPHASE] SELECT LEVEL2',
  CATALOGPHASE_SELECT_LEVEL3: '[CATALOGPHASE] SELECT LEVEL3',
  CATALOGPHASE_SELECT_LEVEL4: '[CATALOGPHASE] SELECT LEVEL4',
  CATALOGPHASE_SELECT_LEVEL5: '[CATALOGPHASE] SELECT LEVEL5',
  CATALOGPHASE_SELECT_LEVEL6: '[CATALOGPHASE] SELECT LEVEL6',
  CATALOGPHASE_CLEAN_LEVEL1: '[CATALOGPHASE] CLEAN LEVEL1',
  CATALOGPHASE_CLEAN_LEVEL2: '[CATALOGPHASE] CLEAN LEVEL2',
  CATALOGPHASE_CLEAN_LEVEL3: '[CATALOGPHASE] CLEAN LEVEL3',
  CATALOGPHASE_CLEAN_LEVEL4: '[CATALOGPHASE] CLEAN LEVEL4',
  CATALOGPHASE_CLEAN_LEVEL5: '[CATALOGPHASE] CLEAN LEVEL5',
  CATALOGPHASE_CLEAN_LEVEL6: '[CATALOGPHASE] CLEAN LEVEL6',

  CATALOGPHASE_START_LOADING_ALL: '[CATALOGPHASE] START LOADING ALL',

  CATALOGPHASE_START_LOADING_NO_LEVEL6: '[CATALOGPHASE] START LOADING NO_LEVEL6',
  CATALOGPHASE_START_LOADING_FILTER: '[CATALOGPHASE] START LOADING FILTER',

  /*
  CATALOGPHASE_CLEAN_LIST_LEVEL1 : '[CATALOGPHASE] CLEAN LIST LEVEL1',
  CATALOGPHASE_CLEAN_LIST_LEVEL2 : '[CATALOGPHASE] CLEAN LIST LEVEL2',
  CATALOGPHASE_CLEAN_LIST_LEVEL3 : '[CATALOGPHASE] CLEAN LIST LEVEL3',
  CATALOGPHASE_CLEAN_LIST_LEVEL4 : '[CATALOGPHASE] CLEAN LIST LEVEL4',
  CATALOGPHASE_CLEAN_LIST_LEVEL5 : '[CATALOGPHASE] CLEAN LIST LEVEL5',
  CATALOGPHASE_CLEAN_LIST_LEVEL6 : '[CATALOGPHASE] CLEAN LIST LEVEL6',
  CATALOGPHASE_CLEAN_SELECT_LEVEL1 : '[CATALOGPHASE] CLEAN SELECT LEVEL1',
  CATALOGPHASE_CLEAN_SELECT_LEVEL2 : '[CATALOGPHASE] CLEAN SELECT LEVEL2',
  CATALOGPHASE_CLEAN_SELECT_LEVEL3 : '[CATALOGPHASE] CLEAN SELECT LEVEL3',
  CATALOGPHASE_CLEAN_SELECT_LEVEL4 : '[CATALOGPHASE] CLEAN SELECT LEVEL4',
  CATALOGPHASE_CLEAN_SELECT_LEVEL5 : '[CATALOGPHASE] CLEAN SELECT LEVEL5',
  CATALOGPHASE_CLEAN_SELECT_LEVEL6 : '[CATALOGPHASE] CLEAN SELECT LEVEL6',
 */

  CATALOGPHASE_START_LOADING_PAGINATED: '[CATALOGPHASE] START LOADING PAGINATED',
  CATALOGPHASE_SELECT: '[CATALOGPHASE] SELECT',
  CATALOGPHASE_CLEAN_SEARCH_PAGINATED: '[CATALOGPHASE] CLEAN SEARCH PAGINATED',
  CATALOGPHASE_CLEAN: '[CATALOGPHASE] CLEAN',
  CATALOGPHASE_UPDATE: '[CATALOGPHASE] UPDATE',
  CATALOGPHASE_DELETE: '[CATALOGPHASE] DELETE',
  CATALOGPHASE_START_REGISTER: '[CATALOGPHASE] START REGISTER',
  CATALOGPHASE_START_SEARCH: '[CATALOGPHASE] START SEARCH',
  CATALOGPHASE_START_SEARCH_PAGINATED: '[CATALOGPHASE] START SEARCH PAGINATED',
  CATALOGPHASE_SET_SEARCH_TEXT: '[CATALOGPHASE] SET SEARCH TEXT',

  CATALOGINSTITUTION_START_LOADING: '[CATALOGINSTITUTION] START LOADING',
  CATALOGINSTITUTION_START_LOADING_LEVEL1: '[CATALOGINSTITUTION] START LOADING LEVEL1',
  CATALOGINSTITUTION_START_LOADING_LEVEL2: '[CATALOGINSTITUTION] START LOADING LEVEL2',
  CATALOGINSTITUTION_START_LOADING_LEVEL3: '[CATALOGINSTITUTION] START LOADING LEVEL3',
  CATALOGINSTITUTION_START_LOADING_LEVEL4: '[CATALOGINSTITUTION] START LOADING LEVEL4',
  CATALOGINSTITUTION_START_LOADING_LEVEL5: '[CATALOGINSTITUTION] START LOADING LEVEL5',
  CATALOGINSTITUTION_START_LOADING_LEVEL6: '[CATALOGINSTITUTION] START LOADING LEVEL6',
  CATALOGINSTITUTION_START_LOADING_ALL_LEVEL6: '[CATALOGINSTITUTION] START LOADING ALL LEVEL6',
  CATALOGINSTITUTION_SELECT_LEVEL1: '[CATALOGINSTITUTION] SELECT LEVEL1',
  CATALOGINSTITUTION_SELECT_LEVEL2: '[CATALOGINSTITUTION] SELECT LEVEL2',
  CATALOGINSTITUTION_SELECT_LEVEL3: '[CATALOGINSTITUTION] SELECT LEVEL3',
  CATALOGINSTITUTION_SELECT_LEVEL4: '[CATALOGINSTITUTION] SELECT LEVEL4',
  CATALOGINSTITUTION_SELECT_LEVEL5: '[CATALOGINSTITUTION] SELECT LEVEL5',
  CATALOGINSTITUTION_SELECT_LEVEL6: '[CATALOGINSTITUTION] SELECT LEVEL6',
  CATALOGINSTITUTION_CLEAN_LEVEL1: '[CATALOGINSTITUTION] CLEAN LEVEL1',
  CATALOGINSTITUTION_CLEAN_LEVEL2: '[CATALOGINSTITUTION] CLEAN LEVEL2',
  CATALOGINSTITUTION_CLEAN_LEVEL3: '[CATALOGINSTITUTION] CLEAN LEVEL3',
  CATALOGINSTITUTION_CLEAN_LEVEL4: '[CATALOGINSTITUTION] CLEAN LEVEL4',
  CATALOGINSTITUTION_CLEAN_LEVEL5: '[CATALOGINSTITUTION] CLEAN LEVEL5',
  CATALOGINSTITUTION_CLEAN_LEVEL6: '[CATALOGINSTITUTION] CLEAN LEVEL6',

  CATALOGINSTITUTION_START_LOADING_ALL: '[CATALOGINSTITUTION] START LOADING ALL',

  CATALOGINSTITUTION_START_LOADING_NO_LEVEL6: '[CATALOGINSTITUTION] START LOADING NO_LEVEL6',
  CATALOGINSTITUTION_START_LOADING_FILTER: '[CATALOGINSTITUTION] START LOADING FILTER',

  /*
  CATALOGINSTITUTION_CLEAN_LIST_LEVEL1 : '[CATALOGINSTITUTION] CLEAN LIST LEVEL1',
  CATALOGINSTITUTION_CLEAN_LIST_LEVEL2 : '[CATALOGINSTITUTION] CLEAN LIST LEVEL2',
  CATALOGINSTITUTION_CLEAN_LIST_LEVEL3 : '[CATALOGINSTITUTION] CLEAN LIST LEVEL3',
  CATALOGINSTITUTION_CLEAN_LIST_LEVEL4 : '[CATALOGINSTITUTION] CLEAN LIST LEVEL4',
  CATALOGINSTITUTION_CLEAN_LIST_LEVEL5 : '[CATALOGINSTITUTION] CLEAN LIST LEVEL5',
  CATALOGINSTITUTION_CLEAN_LIST_LEVEL6 : '[CATALOGINSTITUTION] CLEAN LIST LEVEL6',
  CATALOGINSTITUTION_CLEAN_SELECT_LEVEL1 : '[CATALOGINSTITUTION] CLEAN SELECT LEVEL1',
  CATALOGINSTITUTION_CLEAN_SELECT_LEVEL2 : '[CATALOGINSTITUTION] CLEAN SELECT LEVEL2',
  CATALOGINSTITUTION_CLEAN_SELECT_LEVEL3 : '[CATALOGINSTITUTION] CLEAN SELECT LEVEL3',
  CATALOGINSTITUTION_CLEAN_SELECT_LEVEL4 : '[CATALOGINSTITUTION] CLEAN SELECT LEVEL4',
  CATALOGINSTITUTION_CLEAN_SELECT_LEVEL5 : '[CATALOGINSTITUTION] CLEAN SELECT LEVEL5',
  CATALOGINSTITUTION_CLEAN_SELECT_LEVEL6 : '[CATALOGINSTITUTION] CLEAN SELECT LEVEL6',
 */

  CATALOGINSTITUTION_START_LOADING_PAGINATED: '[CATALOGINSTITUTION] START LOADING PAGINATED',
  CATALOGINSTITUTION_SELECT: '[CATALOGINSTITUTION] SELECT',
  CATALOGINSTITUTION_CLEAN_SEARCH_PAGINATED: '[CATALOGINSTITUTION] CLEAN SEARCH PAGINATED',
  CATALOGINSTITUTION_CLEAN: '[CATALOGINSTITUTION] CLEAN',
  CATALOGINSTITUTION_UPDATE: '[CATALOGINSTITUTION] UPDATE',
  CATALOGINSTITUTION_DELETE: '[CATALOGINSTITUTION] DELETE',
  CATALOGINSTITUTION_START_REGISTER: '[CATALOGINSTITUTION] START REGISTER',
  CATALOGINSTITUTION_START_SEARCH: '[CATALOGINSTITUTION] START SEARCH',
  CATALOGINSTITUTION_START_SEARCH_PAGINATED: '[CATALOGINSTITUTION] START SEARCH PAGINATED',
  CATALOGINSTITUTION_SET_SEARCH_TEXT: '[CATALOGINSTITUTION] SET SEARCH TEXT',

  LOCATION_START_LOADING_COUNTRIES: '[LOCATION] START LOADING COUNTRIES',
  LOCATION_START_LOADING_PROVINCES: '[LOCATION] START LOADING PROVINCES',
  LOCATION_START_LOADING_CANTONS: '[LOCATION] START LOADING CANTONS',
  LOCATION_START_LOADING_PARISHS: '[LOCATION] START LOADING PARISHS',
  LOCATION_SELECT_COUNTRY: '[LOCATION] SELECT COUNTRY',
  LOCATION_SELECT_PROVINCE: '[LOCATION] SELECT PROVINCE',
  LOCATION_SELECT_CANTON: '[LOCATION] SELECT CANTON',
  LOCATION_SELECT_PARISH: '[LOCATION] SELECT PARISH',
  LOCATION_CLEAN_COUNTRY: '[LOCATION] CLEAN COUNTRY',
  LOCATION_CLEAN_PROVINCE: '[LOCATION] CLEAN PROVINCE',
  LOCATION_CLEAN_CANTON: '[LOCATION] CLEAN CANTON',
  LOCATION_CLEAN_PARISH: '[LOCATION] CLEAN PARISH',

  LOCATION_START_LOADING_PAGINATED: '[LOCATION] START LOADING PAGINATED',
  LOCATION_SELECT: '[LOCATION] SELECT',
  LOCATION_CLEAN_SEARCH_PAGINATED: '[LOCATION] CLEAN SEARCH PAGINATED',
  LOCATION_CLEAN: '[LOCATION] CLEAN',
  LOCATION_UPDATE: '[LOCATION] UPDATE',
  LOCATION_DELETE: '[LOCATION] DELETE',
  LOCATION_START_REGISTER: '[LOCATION] START REGISTER',
  LOCATION_START_SEARCH: '[LOCATION] START SEARCH',
  LOCATION_START_SEARCH_PAGINATED: '[LOCATION] START SEARCH PAGINATED',
  LOCATION_SET_SEARCH_TEXT: '[LOCATION] SET SEARCH TEXT',

  TECHNOLOGY_START_REGISTER_ADMIN: '[TECHNOLOGY] START REGISTER_ADMIN',
  TECHNOLOGY_UPDATE: '[TECHNOLOGY] UPDATE',
  TECHNOLOGY_DELETE: '[TECHNOLOGY] DELETE',
  TECHNOLOGY_START_LOADING_PAGINATED: '[TECHNOLOGY] START LOADING PAGINATED',
  TECHNOLOGY_START_LOADING_TECHNOLOGY_PAGINATED: '[TECHNOLOGY] START LOADING TECHNOLOGY PAGINATED',
  TECHNOLOGY_START_SEARCH_PAGINATED: '[TECHNOLOGY] START SEARCH PAGINATED',
  TECHNOLOGY_SELECT: '[TECHNOLOGY] SELECT',
  TECHNOLOGY_CLEAN_SEARCH_PAGINATED: '[TECHNOLOGY] CLEAN SEARCH PAGINATED',
  TECHNOLOGY_CLEAN_PAGINATED: '[TECHNOLOGY] CLEAN PAGINATED',
  TECHNOLOGY_SET_SEARCH_TEXT: '[TECHNOLOGY] SET SEARCH TEXT',
  TECHNOLOGY_CLEAN_SEARCH_TEXT: '[TECHNOLOGY] CLEAN SEARCH TEXT',
  TECHNOLOGY_CLEAN_SAVED: '[TECHNOLOGY] CLEAN SAVED',
  TECHNOLOGY_LIST_UPDATE_SELECTED: '[TECHNOLOGY] LIST UPDATE SELECTED',
  TECHNOLOGY_GET_MORE_THAN_ONE_SELECTED: '[TECHNOLOGY] GET MORETHAN ONE SELECTED',
  TECHNOLOGY_LIST_SET_NUMBER_SELECTED: '[TECHNOLOGY] LIST SET NUMBER SELECTED',
  TECHNOLOGY_CLEAN_SEARCH_INFORMATION: '[TECHNOLOGY] CLEAN SEARCH INFORMATION',
  TECHNOLOGY_IS_LOADING: '[TECHNOLOGY] IS LOADING',
  TECHNOLOGY_IS_LOADING_FINISH: '[TECHNOLOGY] IS LOADING FINISH',
  TECHNOLOGY_CLEAN_NUMBER_OF_SELECTED: '[TECHNOLOGY] CLEAN NUMBER OF SELECTED',
  TECHNOLOGY_CLEAN_NUMBER_OF_COMPARED: '[TECHNOLOGY] CLEAN NUMBER OF COMPARED',
  TECHNOLOGY_CLEAN_NUMBER_OF_SELECTED_COMPARED: '[TECHNOLOGY] CLEAN NUMBER OF SELECTED COMPARED',
  TECHNOLOGY_SELECT_ALL_LIMIT: '[TECHNOLOGY] SELECT ALL LIMIT',
  TECHNOLOGY_CLEAN_ALL_SELECTED: '[TECHNOLOGY] CLEAN ALL SELECTED',
  TECHNOLOGY_CLEAN_ALL_WITHOUT_LIST:'[TECHNOLOGY] CLEAN ALL WITHOUT LIST',

  ALTERNATIVE_START_REGISTER_ADMIN: '[ALTERNATIVE] START REGISTER_ADMIN',
  ALTERNATIVE_UPDATE: '[ALTERNATIVE] UPDATE',
  ALTERNATIVE_DELETE: '[ALTERNATIVE] DELETE',
  ALTERNATIVE_START_LOADING_PAGINATED: '[ALTERNATIVE] START LOADING PAGINATED',
  ALTERNATIVE_START_LOADING_ALTERNATIVE_PAGINATED: '[ALTERNATIVE] START LOADING ALTERNATIVE PAGINATED',
  ALTERNATIVE_START_SEARCH_PAGINATED: '[ALTERNATIVE] START SEARCH PAGINATED',
  ALTERNATIVE_SELECT: '[ALTERNATIVE] SELECT',
  ALTERNATIVE_CLEAN_SEARCH_PAGINATED: '[ALTERNATIVE] CLEAN SEARCH PAGINATED',
  ALTERNATIVE_CLEAN_PAGINATED: '[ALTERNATIVE] CLEAN PAGINATED',
  ALTERNATIVE_SET_SEARCH_TEXT: '[ALTERNATIVE] SET SEARCH TEXT',
  ALTERNATIVE_CLEAN_SEARCH_TEXT: '[ALTERNATIVE] CLEAN SEARCH TEXT',
  ALTERNATIVE_CLEAN_SAVED: '[ALTERNATIVE] CLEAN SAVED',
  ALTERNATIVE_LIST_UPDATE_SELECTED: '[ALTERNATIVE] LIST UPDATE SELECTED',
  ALTERNATIVE_GET_MORE_THAN_ONE_SELECTED: '[ALTERNATIVE] GET MORETHAN ONE SELECTED',
  ALTERNATIVE_LIST_SET_NUMBER_SELECTED: '[ALTERNATIVE] LIST SET NUMBER SELECTED',
  ALTERNATIVE_CLEAN_SEARCH_INFORMATION: '[ALTERNATIVE] CLEAN SEARCH INFORMATION',
  ALTERNATIVE_IS_LOADING: '[ALTERNATIVE] IS LOADING',
  ALTERNATIVE_IS_LOADING_FINISH: '[ALTERNATIVE] IS LOADING FINISH',
  ALTERNATIVE_SELECT_ALL_LIMIT: '[ALTERNATIVE] SELECT ALL LIMIT',
  ALTERNATIVE_CLEAN_ALL_SELECTED: '[ALTERNATIVE] CLEAN ALL SELECTED',
  ALTERNATIVE_CLEAN_ALL_WITHOUT_LIST:'[ALTERNATIVE] CLEAN ALL WITHOUT LIST',

  EXPERIENCE_START_REGISTER_ADMIN: '[EXPERIENCE] START REGISTER_ADMIN',
  EXPERIENCE_UPDATE: '[EXPERIENCE] UPDATE',
  EXPERIENCE_DELETE: '[EXPERIENCE] DELETE',
  EXPERIENCE_START_LOADING_PAGINATED: '[EXPERIENCE] START LOADING PAGINATED',
  EXPERIENCE_START_LOADING_EXPERIENCE_PAGINATED: '[EXPERIENCE] START LOADING EXPERIENCE PAGINATED',
  EXPERIENCE_START_SEARCH_PAGINATED: '[EXPERIENCE] START SEARCH PAGINATED',
  EXPERIENCE_SELECT: '[EXPERIENCE] SELECT',
  EXPERIENCE_CLEAN_SEARCH_PAGINATED: '[EXPERIENCE] CLEAN SEARCH PAGINATED',
  EXPERIENCE_CLEAN_PAGINATED: '[EXPERIENCE] CLEAN PAGINATED',
  EXPERIENCE_SET_SEARCH_TEXT: '[EXPERIENCE] SET SEARCH TEXT',
  EXPERIENCE_CLEAN_SEARCH_TEXT: '[EXPERIENCE] CLEAN SEARCH TEXT',
  EXPERIENCE_CLEAN_SAVED: '[EXPERIENCE] CLEAN SAVED',
  EXPERIENCE_LIST_UPDATE_SELECTED: '[EXPERIENCE] LIST UPDATE SELECTED',
  EXPERIENCE_GET_MORE_THAN_ONE_SELECTED: '[EXPERIENCE] GET MORETHAN ONE SELECTED',
  EXPERIENCE_LIST_SET_NUMBER_SELECTED: '[EXPERIENCE] LIST SET NUMBER SELECTED',
  EXPERIENCE_CLEAN_SEARCH_INFORMATION: '[EXPERIENCE] CLEAN SEARCH INFORMATION',
  EXPERIENCE_IS_LOADING: '[EXPERIENCE] IS LOADING',
  EXPERIENCE_IS_LOADING_FINISH: '[EXPERIENCE] IS LOADING FINISH',
  EXPERIENCE_SELECT_ALL_LIMIT: '[EXPERIENCE] SELECT ALL LIMIT',
  EXPERIENCE_CLEAN_ALL_SELECTED: '[EXPERIENCE] CLEAN ALL SELECTED',
  EXPERIENCE_CLEAN_ALL_WITHOUT_LIST:'[EXPERIENCE] CLEAN ALL WITHOUT LIST',

  INNOVATION_START_REGISTER_ADMIN: '[INNOVATION] START REGISTER_ADMIN',
  INNOVATION_UPDATE: '[INNOVATION] UPDATE',
  INNOVATION_DELETE: '[INNOVATION] DELETE',
  INNOVATION_START_LOADING_PAGINATED: '[INNOVATION] START LOADING PAGINATED',
  INNOVATION_START_LOADING_INNOVATION_PAGINATED: '[INNOVATION] START LOADING INNOVATION PAGINATED',
  INNOVATION_START_SEARCH_PAGINATED: '[INNOVATION] START SEARCH PAGINATED',
  INNOVATION_SELECT: '[INNOVATION] SELECT',
  INNOVATION_CLEAN_SEARCH_PAGINATED: '[INNOVATION] CLEAN SEARCH PAGINATED',
  INNOVATION_CLEAN_PAGINATED: '[INNOVATION] CLEAN PAGINATED',
  INNOVATION_SET_SEARCH_TEXT: '[INNOVATION] SET SEARCH TEXT',
  INNOVATION_CLEAN_SEARCH_TEXT: '[INNOVATION] CLEAN SEARCH TEXT',
  INNOVATION_CLEAN_SAVED: '[INNOVATION] CLEAN SAVED',
  INNOVATION_LIST_UPDATE_SELECTED: '[INNOVATION] LIST UPDATE SELECTED',
  INNOVATION_GET_MORE_THAN_ONE_SELECTED: '[INNOVATION] GET MORETHAN ONE SELECTED',
  INNOVATION_LIST_SET_NUMBER_SELECTED: '[INNOVATION] LIST SET NUMBER SELECTED',
  INNOVATION_CLEAN_SEARCH_INFORMATION: '[INNOVATION] CLEAN SEARCH INFORMATION',
  INNOVATION_IS_LOADING: '[INNOVATION] IS LOADING',
  INNOVATION_IS_LOADING_FINISH: '[INNOVATION] IS LOADING FINISH',
  INNOVATION_SELECT_ALL_LIMIT: '[INNOVATION] SELECT ALL LIMIT',
  INNOVATION_CLEAN_ALL_SELECTED: '[INNOVATION] CLEAN ALL SELECTED',
  INNOVATION_CLEAN_ALL_WITHOUT_LIST:'[INNOVATION] CLEAN ALL WITHOUT LIST',

  ASSISTANCE_START_REGISTER_ADMIN: '[ASSISTANCE] START REGISTER_ADMIN',
  ASSISTANCE_UPDATE: '[ASSISTANCE] UPDATE',
  ASSISTANCE_DELETE: '[ASSISTANCE] DELETE',
  ASSISTANCE_START_LOADING_PAGINATED: '[ASSISTANCE] START LOADING PAGINATED',
  ASSISTANCE_START_LOADING_ASSISTANCE_PAGINATED: '[ASSISTANCE] START LOADING ASSISTANCE PAGINATED',
  ASSISTANCE_START_SEARCH_PAGINATED: '[ASSISTANCE] START SEARCH PAGINATED',
  ASSISTANCE_SELECT: '[ASSISTANCE] SELECT',
  ASSISTANCE_CLEAN_SEARCH_PAGINATED: '[ASSISTANCE] CLEAN SEARCH PAGINATED',
  ASSISTANCE_CLEAN_PAGINATED: '[ASSISTANCE] CLEAN PAGINATED',
  ASSISTANCE_SET_SEARCH_TEXT: '[ASSISTANCE] SET SEARCH TEXT',
  ASSISTANCE_CLEAN_SEARCH_TEXT: '[ASSISTANCE] CLEAN SEARCH TEXT',
  ASSISTANCE_CLEAN_SAVED: '[ASSISTANCE] CLEAN SAVED',
  ASSISTANCE_LIST_UPDATE_SELECTED: '[ASSISTANCE] LIST UPDATE SELECTED',
  ASSISTANCE_GET_MORE_THAN_ONE_SELECTED: '[ASSISTANCE] GET MORETHAN ONE SELECTED',
  ASSISTANCE_LIST_SET_NUMBER_SELECTED: '[ASSISTANCE] LIST SET NUMBER SELECTED',
  ASSISTANCE_CLEAN_SEARCH_INFORMATION: '[ASSISTANCE] CLEAN SEARCH INFORMATION',
  ASSISTANCE_IS_LOADING: '[ASSISTANCE] IS LOADING',
  ASSISTANCE_IS_LOADING_FINISH: '[ASSISTANCE] IS LOADING FINISH',
  ASSISTANCE_SELECT_ALL_LIMIT: '[ASSISTANCE] SELECT ALL LIMIT',
  ASSISTANCE_CLEAN_ALL_SELECTED: '[ASSISTANCE] CLEAN ALL SELECTED',
  ASSISTANCE_CLEAN_ALL_WITHOUT_LIST:'[ASSISTANCE] CLEAN ALL WITHOUT LIST',

  FINANCIAL_START_REGISTER_ADMIN: '[FINANCIAL] START REGISTER_ADMIN',
  FINANCIAL_UPDATE: '[FINANCIAL] UPDATE',
  FINANCIAL_DELETE: '[FINANCIAL] DELETE',
  FINANCIAL_START_LOADING_PAGINATED: '[FINANCIAL] START LOADING PAGINATED',
  FINANCIAL_START_LOADING_FINANCIAL_PAGINATED: '[FINANCIAL] START LOADING FINANCIAL PAGINATED',
  FINANCIAL_START_SEARCH_PAGINATED: '[FINANCIAL] START SEARCH PAGINATED',
  FINANCIAL_SELECT: '[FINANCIAL] SELECT',
  FINANCIAL_CLEAN_SEARCH_PAGINATED: '[FINANCIAL] CLEAN SEARCH PAGINATED',
  FINANCIAL_CLEAN_PAGINATED: '[FINANCIAL] CLEAN PAGINATED',
  FINANCIAL_SET_SEARCH_TEXT: '[FINANCIAL] SET SEARCH TEXT',
  FINANCIAL_CLEAN_SEARCH_TEXT: '[FINANCIAL] CLEAN SEARCH TEXT',
  FINANCIAL_CLEAN_SAVED: '[FINANCIAL] CLEAN SAVED',
  FINANCIAL_LIST_UPDATE_SELECTED: '[FINANCIAL] LIST UPDATE SELECTED',
  FINANCIAL_GET_MORE_THAN_ONE_SELECTED: '[FINANCIAL] GET MORETHAN ONE SELECTED',
  FINANCIAL_LIST_SET_NUMBER_SELECTED: '[FINANCIAL] LIST SET NUMBER SELECTED',
  FINANCIAL_CLEAN_SEARCH_INFORMATION: '[FINANCIAL] CLEAN SEARCH INFORMATION',
  FINANCIAL_IS_LOADING: '[FINANCIAL] IS LOADING',
  FINANCIAL_IS_LOADING_FINISH: '[FINANCIAL] IS LOADING FINISH',
  FINANCIAL_SELECT_ALL_LIMIT: '[FINANCIAL] SELECT ALL LIMIT',
  FINANCIAL_CLEAN_ALL_SELECTED: '[FINANCIAL] CLEAN ALL SELECTED',
  FINANCIAL_CLEAN_ALL_WITHOUT_LIST:'[FINANCIAL] CLEAN ALL WITHOUT LIST',

  REGULATION_START_REGISTER_ADMIN: '[REGULATION] START REGISTER_ADMIN',
  REGULATION_UPDATE: '[REGULATION] UPDATE',
  REGULATION_DELETE: '[REGULATION] DELETE',
  REGULATION_START_LOADING_PAGINATED: '[REGULATION] START LOADING PAGINATED',
  REGULATION_START_LOADING_REGULATION_PAGINATED: '[REGULATION] START LOADING REGULATION PAGINATED',
  REGULATION_START_SEARCH_PAGINATED: '[REGULATION] START SEARCH PAGINATED',
  REGULATION_SELECT: '[REGULATION] SELECT',
  REGULATION_CLEAN_SEARCH_PAGINATED: '[REGULATION] CLEAN SEARCH PAGINATED',
  REGULATION_CLEAN_PAGINATED: '[REGULATION] CLEAN PAGINATED',
  REGULATION_SET_SEARCH_TEXT: '[REGULATION] SET SEARCH TEXT',
  REGULATION_CLEAN_SEARCH_TEXT: '[REGULATION] CLEAN SEARCH TEXT',
  REGULATION_CLEAN_SAVED: '[REGULATION] CLEAN SAVED',
  REGULATION_LIST_UPDATE_SELECTED: '[REGULATION] LIST UPDATE SELECTED',
  REGULATION_GET_MORE_THAN_ONE_SELECTED: '[REGULATION] GET MORETHAN ONE SELECTED',
  REGULATION_LIST_SET_NUMBER_SELECTED: '[REGULATION] LIST SET NUMBER SELECTED',
  REGULATION_CLEAN_SEARCH_INFORMATION: '[REGULATION] CLEAN SEARCH INFORMATION',
  REGULATION_IS_LOADING: '[REGULATION] IS LOADING',
  REGULATION_IS_LOADING_FINISH: '[REGULATION] IS LOADING FINISH',
  REGULATION_SELECT_ALL_LIMIT: '[REGULATION] SELECT ALL LIMIT',
  REGULATION_CLEAN_ALL_SELECTED: '[REGULATION] CLEAN ALL SELECTED',

  VISION_START_REGISTER_ADMIN: '[VISION] START REGISTER_ADMIN',
  VISION_UPDATE: '[VISION] UPDATE',
  VISION_DELETE: '[VISION] DELETE',
  VISION_START_LOADING_PAGINATED: '[VISION] START LOADING PAGINATED',
  VISION_START_LOADING_VISION_PAGINATED: '[VISION] START LOADING VISION PAGINATED',
  VISION_START_SEARCH_PAGINATED: '[VISION] START SEARCH PAGINATED',
  VISION_SELECT: '[VISION] SELECT',
  VISION_CLEAN_SEARCH_PAGINATED: '[VISION] CLEAN SEARCH PAGINATED',
  VISION_CLEAN_PAGINATED: '[VISION] CLEAN PAGINATED',
  VISION_SET_SEARCH_TEXT: '[VISION] SET SEARCH TEXT',
  VISION_CLEAN_SEARCH_TEXT: '[VISION] CLEAN SEARCH TEXT',
  VISION_CLEAN_SAVED: '[VISION] CLEAN SAVED',
  VISION_LIST_UPDATE_SELECTED: '[VISION] LIST UPDATE SELECTED',
  VISION_GET_MORE_THAN_ONE_SELECTED: '[VISION] GET MORETHAN ONE SELECTED',
  VISION_LIST_SET_NUMBER_SELECTED: '[VISION] LIST SET NUMBER SELECTED',
  VISION_CLEAN_SEARCH_INFORMATION: '[VISION] CLEAN SEARCH INFORMATION',
  VISION_IS_LOADING: '[VISION] IS LOADING',
  VISION_IS_LOADING_FINISH: '[VISION] IS LOADING FINISH',
  VISION_SELECT_ALL_LIMIT: '[VISION] SELECT ALL LIMIT',
  VISION_CLEAN_ALL_SELECTED: '[VISION] CLEAN ALL SELECTED',

  VISION_THEME_L1_START_LOADING_PAGINATED: '[VISION THEME L1] START LOADING PAGINATED',
  VISION_TOPIC_L2_START_LOADING_PAGINATED: '[VISION TOPIC L2] START LOADING PAGINATED',
  VISION_WORRY_L3_START_LOADING_PAGINATED: '[VISION WORRY L3] START LOADING PAGINATED',
  VISION_VISION_L4_START_LOADING_PAGINATED: '[VISION VISION L4] START LOADING PAGINATED',

  VISION_THEME_L1_START_SEARCH_PAGINATED: '[VISION THEME L1] START SEARCH PAGINATED',
  VISION_TOPIC_L2_START_SEARCH_PAGINATED: '[VISION TOPIC L2] START SEARCH PAGINATED',
  VISION_WORRY_L3_START_SEARCH_PAGINATED: '[VISION WORRY L3] START SEARCH PAGINATED',
  VISION_VISION_L4_START_SEARCH_PAGINATED: '[VISION VISION L4] START SEARCH PAGINATED',

  VISION_THEME_L1_START_LOADING_ALL: '[VISION THEME L1] START LOADING ALL',
  VISION_TOPIC_L2_START_LOADING_ALL: '[VISION TOPIC L2] START LOADING ALL',
  VISION_WORRY_L3_START_LOADING_ALL: '[VISION WORRY L3] START LOADING ALL',
  VISION_VISION_L4_START_LOADING_ALL: '[VISION VISION L4] START LOADING ALL',

  VISION_L1_START_REGISTER_ADMIN: '[VISION L1] START REGISTER_ADMIN',
  VISION_L1_UPDATE: '[VISION L1] UPDATE',
  VISION_L1_DELETE: '[VISION L1] DELETE',

  VISION_L2_START_REGISTER_ADMIN: '[VISION L2] START REGISTER_ADMIN',
  VISION_L2_UPDATE: '[VISION L2] UPDATE',
  VISION_L2_DELETE: '[VISION L2] DELETE',

  VISION_L3_START_REGISTER_ADMIN: '[VISION L3] START REGISTER_ADMIN',
  VISION_L3_UPDATE: '[VISION L3] UPDATE',
  VISION_L3_DELETE: '[VISION L3] DELETE',

  VISION_L4_START_REGISTER_ADMIN: '[VISION L4] START REGISTER_ADMIN',
  VISION_L4_UPDATE: '[VISION L4] UPDATE',
  VISION_L4_DELETE: '[VISION L4] DELETE',

  VISION_L1_CLEAN_SEARCH_PAGINATED: '[VISION L1] CLEAN SEARCH PAGINATED',
  VISION_L2_CLEAN_SEARCH_PAGINATED: '[VISION L2] CLEAN SEARCH PAGINATED',
  VISION_L3_CLEAN_SEARCH_PAGINATED: '[VISION L3] CLEAN SEARCH PAGINATED',
  VISION_L4_CLEAN_SEARCH_PAGINATED: '[VISION L4] CLEAN SEARCH PAGINATED',

  VISION_L1_SET_SEARCH_TEXT: '[VISION L1] SET SEARCH TEXT',
  VISION_L1_CLEAN_SEARCH_TEXT: '[VISION L1] CLEAN SEARCH TEXT',

  VISION_L2_SET_SEARCH_TEXT: '[VISION L2] SET SEARCH TEXT',
  VISION_L2_CLEAN_SEARCH_TEXT: '[VISION L2] CLEAN SEARCH TEXT',

  VISION_L3_SET_SEARCH_TEXT: '[VISION L3] SET SEARCH TEXT',
  VISION_L3_CLEAN_SEARCH_TEXT: '[VISION L3] CLEAN SEARCH TEXT',

  VISION_L4_SET_SEARCH_TEXT: '[VISION L4] SET SEARCH TEXT',
  VISION_L4_CLEAN_SEARCH_TEXT: '[VISION L4] CLEAN SEARCH TEXT',

  VISION_START_LOADING_FILTER: '[VISION] START LOADING FILTER',

  ALTERNATIVE_TECHNOLOGY_START_LOADING_CIIU_SERIE: '[ALTERNATIVE TECHNOLOGY] START LOADING CIIU SERIE',
  ALTERNATIVE_TECHNOLOGY_START_LOADING_CIIU_SERIE_PAGINATED: '[ALTERNATIVE TECHNOLOGY] START LOADING CIIU SERIE PAGINATED',
  ALTERNATIVE_TECHNOLOGY_START_LOADING_SERIE_CIIU_TECHNOLOGY_PAGINATED: '[ALTERNATIVE TECHNOLOGY] START LOADING SERIE CIIU TEXT PAGINATED',
  ALTERNATIVE_TECHNOLOGY_SELECT: '[ALTERNATIVE TECHNOLOGY] SELECT',

  ALTERNATIVE_TECHNOLOGYS_CLEAN_SEARCH: '[ALTERNATIVE_TECHNOLOGYS] CLEAN SEARCH',

  ALTERNATIVE_TECHNOLOGY_START_LOADING_PAGINATED: '[ALTERNATIVE_TECHNOLOGY] START LOADING PAGINATED',
  ALTERNATIVE_TECHNOLOGY_START_SEARCH_PAGINATED: '[ALTERNATIVE_TECHNOLOGY] START SEARCH PAGINATED',

  ALTERNATIVE_TECHNOLOGY_CLEAN_SEARCH_PAGINATED: '[ALTERNATIVE_TECHNOLOGY] CLEAN SEARCH PAGINATED',
  ALTERNATIVE_TECHNOLOGY_CLEAN_PAGINATED: '[ALTERNATIVE_TECHNOLOGY] CLEAN PAGINATED',

  ALTERNATIVE_TECHNOLOGY_SET_SEARCH_TEXT: '[ALTERNATIVE_TECHNOLOGY] SET SEARCH TEXT',
  ALTERNATIVE_TECHNOLOGY_CLEAN_SEARCH_TEXT: '[ALTERNATIVE_TECHNOLOGY] CLEAN SEARCH TEXT',

  ALTERNATIVE_TECHNOLOGY_START_REGISTER_ADMIN: '[ALTERNATIVE_TECHNOLOGY] START REGISTER_ADMIN',
  ALTERNATIVE_TECHNOLOGY_UPDATE: '[ALTERNATIVE_TECHNOLOGY] UPDATE',
  ALTERNATIVE_TECHNOLOGY_DELETE: '[ALTERNATIVE_TECHNOLOGY] DELETE',

  ALTERNATIVE_TECHNOLOGY_CLEAN_SAVED: '[ALTERNATIVE_TECHNOLOGY] CLEAN SAVED',

  TECHNICAL_INNOVATION_START_LOADING_CIIU_SERIE: '[TECHNICAL INNOVATION] START LOADING CIIU SERIE',
  TECHNICAL_INNOVATION_START_LOADING_CIIU_SERIE_PAGINATED: '[TECHNICAL INNOVATION] START LOADING CIIU SERIE PAGINATED',
  TECHNICAL_INNOVATION_START_LOADING_SERIE_CIIU_TECHNOLOGY_PAGINATED: '[TECHNICAL INNOVATION] START LOADING SERIE CIIU TEXT PAGINATED',
  TECHNICAL_INNOVATION_SELECT: '[TECHNICAL INNOVATION] SELECT',

  TECHNICAL_INNOVATIONS_CLEAN_SEARCH: '[TECHNICAL_INNOVATIONS] CLEAN SEARCH',

  TECHNICAL_INNOVATION_START_LOADING_PAGINATED: '[TECHNICAL_INNOVATION] START LOADING PAGINATED',
  TECHNICAL_INNOVATION_START_SEARCH_PAGINATED: '[TECHNICAL_INNOVATION] START SEARCH PAGINATED',

  TECHNICAL_INNOVATION_CLEAN_SEARCH_PAGINATED: '[TECHNICAL_INNOVATION] CLEAN SEARCH PAGINATED',
  TECHNICAL_INNOVATION_CLEAN_PAGINATED: '[TECHNICAL_INNOVATION] CLEAN PAGINATED',

  TECHNICAL_INNOVATION_SET_SEARCH_TEXT: '[TECHNICAL_INNOVATION] SET SEARCH TEXT',
  TECHNICAL_INNOVATION_CLEAN_SEARCH_TEXT: '[TECHNICAL_INNOVATION] CLEAN SEARCH TEXT',

  TECHNICAL_INNOVATION_START_REGISTER_ADMIN: '[TECHNICAL_INNOVATION] START REGISTER_ADMIN',
  TECHNICAL_INNOVATION_UPDATE: '[TECHNICAL_INNOVATION] UPDATE',
  TECHNICAL_INNOVATION_DELETE: '[TECHNICAL_INNOVATION] DELETE',

  TECHNICAL_INNOVATION_CLEAN_SAVED: '[TECHNICAL_INNOVATION] CLEAN SAVED',

  TECHNICAL_ASSISTANCE_START_LOADING_CIIU_SERIE: '[TECHNICAL ASSISTANCE] START LOADING CIIU SERIE',
  TECHNICAL_ASSISTANCE_START_LOADING_CIIU_SERIE_PAGINATED: '[TECHNICAL ASSISTANCE] START LOADING CIIU SERIE PAGINATED',
  TECHNICAL_ASSISTANCE_START_LOADING_SERIE_CIIU_TECHNOLOGY_PAGINATED: '[TECHNICAL ASSISTANCE] START LOADING SERIE CIIU TEXT PAGINATED',
  TECHNICAL_ASSISTANCE_SELECT: '[TECHNICAL ASSISTANCE] SELECT',

  TECHNICAL_ASSISTANCES_CLEAN_SEARCH: '[TECHNICAL_ASSISTANCES] CLEAN SEARCH',

  TECHNICAL_ASSISTANCE_START_LOADING_PAGINATED: '[TECHNICAL_ASSISTANCE] START LOADING PAGINATED',
  TECHNICAL_ASSISTANCE_START_SEARCH_PAGINATED: '[TECHNICAL_ASSISTANCE] START SEARCH PAGINATED',

  TECHNICAL_ASSISTANCE_CLEAN_SEARCH_PAGINATED: '[TECHNICAL_ASSISTANCE] CLEAN SEARCH PAGINATED',
  TECHNICAL_ASSISTANCE_CLEAN_PAGINATED: '[TECHNICAL_ASSISTANCE] CLEAN PAGINATED',

  TECHNICAL_ASSISTANCE_SET_SEARCH_TEXT: '[TECHNICAL_ASSISTANCE] SET SEARCH TEXT',
  TECHNICAL_ASSISTANCE_CLEAN_SEARCH_TEXT: '[TECHNICAL_ASSISTANCE] CLEAN SEARCH TEXT',

  TECHNICAL_ASSISTANCE_START_REGISTER_ADMIN: '[TECHNICAL_ASSISTANCE] START REGISTER_ADMIN',
  TECHNICAL_ASSISTANCE_UPDATE: '[TECHNICAL_ASSISTANCE] UPDATE',
  TECHNICAL_ASSISTANCE_DELETE: '[TECHNICAL_ASSISTANCE] DELETE',

  TECHNICAL_ASSISTANCE_CLEAN_SAVED: '[TECHNICAL_ASSISTANCE] CLEAN SAVED',

  FINANCIAL_ASSISTANCE_START_LOADING_CIIU_SERIE: '[FINANCIAL ASSISTANCE] START LOADING CIIU SERIE',
  FINANCIAL_ASSISTANCE_START_LOADING_CIIU_SERIE_PAGINATED: '[FINANCIAL ASSISTANCE] START LOADING CIIU SERIE PAGINATED',
  FINANCIAL_ASSISTANCE_START_LOADING_SERIE_CIIU_TECHNOLOGY_PAGINATED: '[FINANCIAL ASSISTANCE] START LOADING SERIE CIIU TEXT PAGINATED',
  FINANCIAL_ASSISTANCE_SELECT: '[FINANCIAL ASSISTANCE] SELECT',

  FINANCIAL_ASSISTANCES_CLEAN_SEARCH: '[FINANCIAL_ASSISTANCES] CLEAN SEARCH',

  FINANCIAL_ASSISTANCE_START_LOADING_PAGINATED: '[FINANCIAL_ASSISTANCE] START LOADING PAGINATED',
  FINANCIAL_ASSISTANCE_START_SEARCH_PAGINATED: '[FINANCIAL_ASSISTANCE] START SEARCH PAGINATED',

  FINANCIAL_ASSISTANCE_CLEAN_SEARCH_PAGINATED: '[FINANCIAL_ASSISTANCE] CLEAN SEARCH PAGINATED',
  FINANCIAL_ASSISTANCE_CLEAN_PAGINATED: '[FINANCIAL_ASSISTANCE] CLEAN PAGINATED',

  FINANCIAL_ASSISTANCE_SET_SEARCH_TEXT: '[FINANCIAL_ASSISTANCE] SET SEARCH TEXT',
  FINANCIAL_ASSISTANCE_CLEAN_SEARCH_TEXT: '[FINANCIAL_ASSISTANCE] CLEAN SEARCH TEXT',

  FINANCIAL_ASSISTANCE_START_REGISTER_ADMIN: '[FINANCIAL_ASSISTANCE] START REGISTER_ADMIN',
  FINANCIAL_ASSISTANCE_UPDATE: '[FINANCIAL_ASSISTANCE] UPDATE',
  FINANCIAL_ASSISTANCE_DELETE: '[FINANCIAL_ASSISTANCE] DELETE',

  FINANCIAL_ASSISTANCE_CLEAN_SAVED: '[FINANCIAL_ASSISTANCE] CLEAN SAVED',

  ADAPTATION_MEASURE_START_LOADING_CIIU_SERIE: '[ADAPTATION MEASURE] START LOADING CIIU SERIE',
  ADAPTATION_MEASURE_START_LOADING_CIIU_SERIE_PAGINATED: '[ADAPTATION MEASURE] START LOADING CIIU SERIE PAGINATED',
  ADAPTATION_MEASURE_START_LOADING_SERIE_CIIU_TECHNOLOGY_PAGINATED: '[ADAPTATION MEASURE] START LOADING SERIE CIIU TEXT PAGINATED',
  ADAPTATION_MEASURE_SELECT: '[ADAPTATION MEASURE] SELECT',

  ADAPTATION_MEASURES_CLEAN_SEARCH: '[ADAPTATION_MEASURES] CLEAN SEARCH',

  ADAPTATION_MEASURE_LOADING_PAGINATED: '[ADAPTATION_MEASURE] START LOADING PAGINATED',
  ADAPTATION_MEASURE_START_LOADING_PAGINATED: '[ADAPTATION_MEASURE] START LOADING PAGINATED',
  ADAPTATION_MEASURE_START_SEARCH_PAGINATED: '[ADAPTATION_MEASURE] START SEARCH PAGINATED',

  ADAPTATION_MEASURE_CLEAN_SEARCH_PAGINATED: '[ADAPTATION_MEASURE] CLEAN SEARCH PAGINATED',
  ADAPTATION_MEASURE_CLEAN_PAGINATED: '[ADAPTATION_MEASURE] CLEAN PAGINATED',

  ADAPTATION_MEASURE_SET_SEARCH_TEXT: '[ADAPTATION_MEASURE] SET SEARCH TEXT',
  ADAPTATION_MEASURE_CLEAN_SEARCH_TEXT: '[ADAPTATION_MEASURE] CLEAN SEARCH TEXT',

  ADAPTATION_MEASURE_START_REGISTER_ADMIN: '[ADAPTATION_MEASURE] START REGISTER_ADMIN',
  ADAPTATION_MEASURE_UPDATE: '[ADAPTATION_MEASURE] UPDATE',
  ADAPTATION_MEASURE_DELETE: '[ADAPTATION_MEASURE] DELETE',

  ADAPTATION_MEASURE_CLEAN_SAVED: '[ADAPTATION_MEASURE] CLEAN SAVED',

  ADAPTATION_STRATEGY_START_LOADING_CIIU_SERIE: '[ADAPTATION STRATEGY] START LOADING CIIU SERIE',
  ADAPTATION_STRATEGY_START_LOADING_CIIU_SERIE_PAGINATED: '[ADAPTATION STRATEGY] START LOADING CIIU SERIE PAGINATED',
  ADAPTATION_STRATEGY_START_LOADING_SERIE_CIIU_TECHNOLOGY_PAGINATED: '[ADAPTATION STRATEGY] START LOADING SERIE CIIU TEXT PAGINATED',
  ADAPTATION_STRATEGY_SELECT: '[ADAPTATION STRATEGY] SELECT',

  ADAPTATION_STRATEGYS_CLEAN_SEARCH: '[ADAPTATION_STRATEGYS] CLEAN SEARCH',

  ADAPTATION_STRATEGY_START_LOADING_PAGINATED: '[ADAPTATION_STRATEGY] START LOADING PAGINATED',
  ADAPTATION_STRATEGY_START_SEARCH_PAGINATED: '[ADAPTATION_STRATEGY] START SEARCH PAGINATED',

  ADAPTATION_STRATEGY_CLEAN_SEARCH_PAGINATED: '[ADAPTATION_STRATEGY] CLEAN SEARCH PAGINATED',
  ADAPTATION_STRATEGY_CLEAN_PAGINATED: '[ADAPTATION_STRATEGY] CLEAN PAGINATED',

  ADAPTATION_STRATEGY_SET_SEARCH_TEXT: '[ADAPTATION_STRATEGY] SET SEARCH TEXT',
  ADAPTATION_STRATEGY_CLEAN_SEARCH_TEXT: '[ADAPTATION_STRATEGY] CLEAN SEARCH TEXT',

  ADAPTATION_STRATEGY_START_REGISTER_ADMIN: '[ADAPTATION_STRATEGY] START REGISTER_ADMIN',
  ADAPTATION_STRATEGY_UPDATE: '[ADAPTATION_STRATEGY] UPDATE',
  ADAPTATION_STRATEGY_DELETE: '[ADAPTATION_STRATEGY] DELETE',

  ADAPTATION_STRATEGY_CLEAN_SAVED: '[ADAPTATION_STRATEGY] CLEAN SAVED',

  CONCEPTUAL_VISION_START_LOADING_CIIU_SERIE: '[CONCEPTUAL VISION] START LOADING CIIU SERIE',
  CONCEPTUAL_VISION_START_LOADING_CIIU_SERIE_PAGINATED: '[CONCEPTUAL VISION] START LOADING CIIU SERIE PAGINATED',
  CONCEPTUAL_VISION_START_LOADING_SERIE_CIIU_TECHNOLOGY_PAGINATED: '[CONCEPTUAL VISION] START LOADING SERIE CIIU TEXT PAGINATED',
  CONCEPTUAL_VISION_SELECT: '[CONCEPTUAL VISION] SELECT',

  CONCEPTUAL_VISIONS_CLEAN_SEARCH: '[CONCEPTUAL_VISIONS] CLEAN SEARCH',

  CONCEPTUAL_VISION_START_LOADING_PAGINATED: '[CONCEPTUAL_VISION] START LOADING PAGINATED',
  CONCEPTUAL_VISION_START_SEARCH_PAGINATED: '[CONCEPTUAL_VISION] START SEARCH PAGINATED',

  CONCEPTUAL_VISION_CLEAN_SEARCH_PAGINATED: '[CONCEPTUAL_VISION] CLEAN SEARCH PAGINATED',
  CONCEPTUAL_VISION_CLEAN_PAGINATED: '[CONCEPTUAL_VISION] CLEAN PAGINATED',

  CONCEPTUAL_VISION_SET_SEARCH_TEXT: '[CONCEPTUAL_VISION] SET SEARCH TEXT',
  CONCEPTUAL_VISION_CLEAN_SEARCH_TEXT: '[CONCEPTUAL_VISION] CLEAN SEARCH TEXT',

  CONCEPTUAL_VISION_START_REGISTER_ADMIN: '[CONCEPTUAL_VISION] START REGISTER_ADMIN',
  CONCEPTUAL_VISION_UPDATE: '[CONCEPTUAL_VISION] UPDATE',
  CONCEPTUAL_VISION_DELETE: '[CONCEPTUAL_VISION] DELETE',

  CONCEPTUAL_VISION_CLEAN_SAVED: '[CONCEPTUAL_VISION] CLEAN SAVED',

  CONCEPTUAL_VISION_START_LOADING_TEXT_PAGINATED: '[CONCEPTUAL VISION] START LOADING TEXT PAGINATED',

  INTERNATIONAL_REGULATION_START_LOADING_CIIU_SERIE: '[INTERNATIONAL REGULATION] START LOADING CIIU SERIE',
  INTERNATIONAL_REGULATION_START_LOADING_CIIU_SERIE_PAGINATED: '[INTERNATIONAL REGULATION ] START LOADING CIIU SERIE PAGINATED',
  INTERNATIONAL_REGULATION_START_LOADING_SERIE_CIIU_TECHNOLOGY_PAGINATED: '[INTERNATIONAL REGULATION] START LOADING SERIE CIIU TEXT PAGINATED',
  INTERNATIONAL_REGULATION_SELECT: '[INTERNATIONAL REGULATION] SELECT',

  INTERNATIONAL_REGULATIONS_CLEAN_SEARCH: '[INTERNATIONAL REGULATION] CLEAN SEARCH',

  INTERNATIONAL_REGULATION_START_LOADING_PAGINATED: '[INTERNATIONAL REGULATION] START LOADING PAGINATED',
  INTERNATIONAL_REGULATION_START_SEARCH_PAGINATED: '[INTERNATIONAL REGULATION] START SEARCH PAGINATED',

  INTERNATIONAL_REGULATION_CLEAN_SEARCH_PAGINATED: '[INTERNATIONAL REGULATION] CLEAN SEARCH PAGINATED',
  INTERNATIONAL_REGULATION_CLEAN_PAGINATED: '[INTERNATIONAL REGULATION] CLEAN PAGINATED',

  INTERNATIONAL_REGULATION_SET_SEARCH_TEXT: '[INTERNATIONAL_REGULATION] SET SEARCH TEXT',
  INTERNATIONAL_REGULATION_CLEAN_SEARCH_TEXT: '[INTERNATIONAL_REGULATION] CLEAN SEARCH TEXT',

  INTERNATIONAL_REGULATION_START_REGISTER_ADMIN: '[INTERNATIONAL_REGULATION] START REGISTER_ADMIN',
  INTERNATIONAL_REGULATION_UPDATE: '[INTERNATIONAL_REGULATION] UPDATE',
  INTERNATIONAL_REGULATION_DELETE: '[INTERNATIONAL_REGULATION] DELETE',

  INTERNATIONAL_REGULATION_CLEAN_SAVED: '[INTERNATIONAL REGULATION] CLEAN SAVED',

  SEARCH_INFO_SET_SEARCH_SERIE_TEXT: '[SEARCH_INFO] SET SEARCH SERIE TEXT',
  SEARCH_INFO_SET_SEARCH_CIIU_TEXT: '[SEARCH_INFO] SET SEARCH CIIU TEXT',
  SEARCH_INFO_SET_SEARCH_TEXT: '[SEARCH_INFO] SET SEARCH TEXT',

  SEARCH_INFO_CLEAN_SEARCH_SERIE_TEXT: '[SEARCH_INFO] CLEAN SEARCH SERIE TEXT',
  SEARCH_INFO_CLEAN_SEARCH_CIIU_TEXT: '[SEARCH_INFO] CLEAN SEARCH CIIU TEXT',
  SEARCH_INFO_CLEAN_SEARCH_TEXT: '[SEARCH_INFO] CLEAN SEARCH TEXT',

  SEARCH_INFO_SET_SEARCH_CONCEPTUAL_VISION_TEXT: '[SEARCH_INFO] SET SEARCH CONCEPTUAL_VISION TEXT',
  SEARCH_INFO_CLEAN_SEARCH_CONCEPTUAL_VISION_TEXT: '[SEARCH_INFO] CLEAN SEARCH CONCEPTUAL_VISION TEXT',

  SUPPLIER_START_LOADING_BY_SUPPLIER_TYPE_PAGINATED: '[SUPPLIER] START LOADING BY SUPPLIER TYPE',

  SOURCE_INFORMATION_START_LOADING_PAGINATED: '[SOURCE_INFORMATION] START LOADING',

  FILE_START_LOADING_BY_ADAPTATION_MEASURE_ID: '[FILE] START LOADING BY ADAPTATION MEASURE ID',
  ADAPTATION_MEASURE_FILE_START_LOADING_BY_ADAPTATION_MEASURE_ID: '[ADAPTATION_MEASURE FILE] START LOADING BY ADAPTATION_MEASURE ID',

  CATALOGCIIU_INFO_START_LOADING_BY_ID: '[CATALOGCIIU_INFO] START LOADING BY ID',

  NATURAL_PHENOMENON_TECHNOLOGY_START_REGISTER_LIST: '[NATURAL_PHENOMENON_TECHNOLOGY] START REGISTER LIST',
  NATURAL_PHENOMENON_ALTERNATIVE_TECHNOLOGY_START_REGISTER_LIST: '[NATURAL_PHENOMENON_ALTERNATIVE_TECHNOLOGY] START REGISTER LIST',
  NATURAL_PHENOMENON_TECHNICAL_INNOVATION_START_REGISTER_LIST: '[NATURAL_PHENOMENON_TECHNICAL_INNOVATION] START REGISTER LIST',
  NATURAL_PHENOMENON_ADAPTATION_STRATEGY_START_REGISTER_LIST: '[NATURAL_PHENOMENON_ADAPTATION_STRATEGY] START REGISTER LIST',

  LOCATIONCOUNTRY_START_LOADING_CONTINENT: '[LOCATIONCOUNTRY] START LOADING CONTINENT',
  LOCATIONCOUNTRY_START_LOADING_REGION: '[LOCATIONCOUNTRY] START LOADING REGION',
  LOCATIONCOUNTRY_START_LOADING_COUNTRY: '[LOCATIONCOUNTRY] START LOADING COUNTRY',

  LOCATIONCOUNTRY_SELECT_CONTINENT_INITIAL: '[LOCATIONCOUNTRY] SELECT CONTINENT INITIAL',
  LOCATIONCOUNTRY_SELECT_REGION_INITIAL: '[LOCATIONCOUNTRY] SELECT REGION INITIAL',
  LOCATIONCOUNTRY_SELECT_COUNTRY_INITIAL: '[LOCATIONCOUNTRY] SELECT COUNTRY INITIAL',

  LOCATIONCOUNTRY_SELECT_CONTINENT: '[LOCATIONCOUNTRY] SELECT CONTINENT',
  LOCATIONCOUNTRY_SELECT_REGION: '[LOCATIONCOUNTRY] SELECT REGION',
  LOCATIONCOUNTRY_SELECT_COUNTRY: '[LOCATIONCOUNTRY] SELECT COUNTRY',

  LOCATIONCOUNTRY_CLEAN_CONTINENT: '[LOCATIONCOUNTRY] CLEAN CONTINENT',
  LOCATIONCOUNTRY_CLEAN_REGION: '[LOCATIONCOUNTRY] CLEAN REGION',
  LOCATIONCOUNTRY_CLEAN_COUNTRY: '[LOCATIONCOUNTRY] CLEAN COUNTRY',

  LOCATIONCOUNTRY_START_LOADING_ONE_COUNTRY: '[LOCATIONCOUNTRY] START LOADING ONE COUNTRY',

  LOCATIONCOUNTRY_START_LOADING_REGION_ALL: '[LOCATIONCOUNTRY] START LOADING REGION ALL',
  LOCATIONCOUNTRY_START_LOADING_COUNTRY_ALL: '[LOCATIONCOUNTRY] START LOADING COUNTRY ALL',

  LOCATIONCOUNTRY_START_LOADING_FILTER: '[LOCATIONCOUNTRY] START LOADING FILTER',

  CONTINENT_START_LOADING: '[CONTINENT] START LOADING',
  CONTINENT_START_LOADING_PAGINATED: '[CONTINENT] START LOADING PAGINATED',
  CONTINENT_SELECT: '[CONTINENT] SELECT',
  CONTINENT_CLEAN_SEARCH_PAGINATED: '[CONTINENT] CLEAN SEARCH PAGINATED',
  CONTINENT_CLEAN: '[CONTINENT] CLEAN',
  CONTINENT_UPDATE: '[CONTINENT] UPDATE',
  CONTINENT_DELETE: '[CONTINENT] DELETE',
  CONTINENT_START_REGISTER: '[CONTINENT] START REGISTER',
  CONTINENT_START_SEARCH: '[CONTINENT] START SEARCH',
  CONTINENT_START_SEARCH_PAGINATED: '[CONTINENT] START SEARCH PAGINATED',
  CONTINENT_SET_SEARCH_TEXT: '[CONTINENT] SET SEARCH TEXT',
  CONTINENT_START_LOADING_ALL: '[CONTINENT] START LOADING ALL',

  REGION_START_LOADING: '[REGION] START LOADING',
  REGION_START_LOADING_PAGINATED: '[REGION] START LOADING PAGINATED',
  REGION_SELECT: '[REGION] SELECT',
  REGION_CLEAN_SEARCH_PAGINATED: '[REGION] CLEAN SEARCH PAGINATED',
  REGION_CLEAN: '[REGION] CLEAN',
  REGION_UPDATE: '[REGION] UPDATE',
  REGION_DELETE: '[REGION] DELETE',
  REGION_START_REGISTER: '[REGION] START REGISTER',
  REGION_START_SEARCH: '[REGION] START SEARCH',
  REGION_START_SEARCH_PAGINATED: '[REGION] START SEARCH PAGINATED',
  REGION_SET_SEARCH_TEXT: '[REGION] SET SEARCH TEXT',
  REGION_START_LOADING_ALL: '[REGION] START LOADING ALL',

  COUNTRY_START_LOADING: '[COUNTRY] START LOADING',
  COUNTRY_START_LOADING_PAGINATED: '[COUNTRY] START LOADING PAGINATED',
  COUNTRY_SELECT: '[COUNTRY] SELECT',
  COUNTRY_CLEAN_SEARCH_PAGINATED: '[COUNTRY] CLEAN SEARCH PAGINATED',
  COUNTRY_CLEAN: '[COUNTRY] CLEAN',
  COUNTRY_UPDATE: '[COUNTRY] UPDATE',
  COUNTRY_DELETE: '[COUNTRY] DELETE',
  COUNTRY_START_REGISTER: '[COUNTRY] START REGISTER',
  COUNTRY_START_SEARCH: '[COUNTRY] START SEARCH',
  COUNTRY_START_SEARCH_PAGINATED: '[COUNTRY] START SEARCH PAGINATED',
  COUNTRY_SET_SEARCH_TEXT: '[COUNTRY] SET SEARCH TEXT',
  COUNTRY_START_LOADING_ALL: '[COUNTRY] START LOADING ALL',

  VIEW_MODAL_OPEN: '[VIEW] MODAL OPEN',
  VIEW_MODAL_CLOSE: '[VIEW] MODAL CLOSE',

  SUBJECT_START_LOADING_CIIU_SERIE: '[SUBJECT] START LOADING CIIU SERIE',
  SUBJECT_START_LOADING_CIIU_SERIE_PAGINATED: '[SUBJECT] START LOADING CIIU SERIE PAGINATED',
  SUBJECT_START_LOADING_SERIE_CIIU_TECHNOLOGY_PAGINATED: '[SUBJECT] START LOADING SERIE CIIU TEXT PAGINATED',
  SUBJECT_SELECT: '[SUBJECT] SELECT',

  SUBJECTS_CLEAN_SEARCH: '[SUBJECTS] CLEAN SEARCH',

  SUBJECT_START_LOADING_PAGINATED: '[SUBJECT] START LOADING PAGINATED',
  SUBJECT_START_SEARCH_PAGINATED: '[SUBJECT] START SEARCH PAGINATED',

  SUBJECT_CLEAN_SEARCH_PAGINATED: '[SUBJECT] CLEAN SEARCH PAGINATED',
  SUBJECT_CLEAN_PAGINATED: '[SUBJECT] CLEAN PAGINATED',

  SUBJECT_SET_SEARCH_TEXT: '[SUBJECT] SET SEARCH TEXT',
  SUBJECT_CLEAN_SEARCH_TEXT: '[SUBJECT] CLEAN SEARCH TEXT',

  SUBJECT_START_REGISTER_ADMIN: '[SUBJECT] START REGISTER_ADMIN',
  SUBJECT_UPDATE: '[SUBJECT] UPDATE',
  SUBJECT_DELETE: '[SUBJECT] DELETE',

  SUBJECT_CLEAN_SAVED: '[SUBJECT] CLEAN SAVED',

  SUBJECT_START_LOADING_TEXT_PAGINATED: '[SUBJECT] START LOADING TEXT PAGINATED',

  TOPIC_START_LOADING_CIIU_SERIE: '[TOPIC] START LOADING CIIU SERIE',
  TOPIC_START_LOADING_CIIU_SERIE_PAGINATED: '[TOPIC] START LOADING CIIU SERIE PAGINATED',
  TOPIC_START_LOADING_SERIE_CIIU_TECHNOLOGY_PAGINATED: '[TOPIC] START LOADING SERIE CIIU TEXT PAGINATED',
  TOPIC_SELECT: '[TOPIC] SELECT',

  TOPICS_CLEAN_SEARCH: '[TOPICS] CLEAN SEARCH',

  TOPIC_START_LOADING_PAGINATED: '[TOPIC] START LOADING PAGINATED',
  TOPIC_START_SEARCH_PAGINATED: '[TOPIC] START SEARCH PAGINATED',

  TOPIC_CLEAN_SEARCH_PAGINATED: '[TOPIC] CLEAN SEARCH PAGINATED',
  TOPIC_CLEAN_PAGINATED: '[TOPIC] CLEAN PAGINATED',

  TOPIC_SET_SEARCH_TEXT: '[TOPIC] SET SEARCH TEXT',
  TOPIC_CLEAN_SEARCH_TEXT: '[TOPIC] CLEAN SEARCH TEXT',

  TOPIC_START_REGISTER_ADMIN: '[TOPIC] START REGISTER_ADMIN',
  TOPIC_UPDATE: '[TOPIC] UPDATE',
  TOPIC_DELETE: '[TOPIC] DELETE',

  TOPIC_CLEAN_SAVED: '[TOPIC] CLEAN SAVED',

  TOPIC_START_LOADING_TEXT_PAGINATED: '[TOPIC] START LOADING TEXT PAGINATED',

  TOPIC_START_LOADING_BY_SUBJECT_ID: '[TOPIC] START LOADING BY SUBJECT ID',
  TOPIC_START_LOADING_TEXT: '[TOPIC] START LOADING TEXT',

  TOPIC_CLEAN_BY_PARENT: '[TOPIC] CLEAN BY PARENT',
  TOPIC_CLEAN_BY_TEXT: '[TOPIC] CLEAN BY TEXT',

  MODULE_CONFIG_START_LOADING_BY_ROLE_PROCESS: '[MODULE_CONFIG] START LOADING BY ROLE PROCESS',
  
  MODULE_CONFIGURATION_START_LOADING: '[MODULE_CONFIGURATION] START LOADING',
  MODULE_CONFIGURATION_START_LOADING_PAGINATED: '[MODULE_CONFIGURATION] START LOADING PAGINATED',
  MODULE_CONFIGURATION_SELECT: '[MODULE_CONFIGURATION] SELECT',
  MODULE_CONFIGURATION_CLEAN_SEARCH_PAGINATED: '[MODULE_CONFIGURATION] CLEAN SEARCH PAGINATED',
  MODULE_CONFIGURATION_CLEAN: '[MODULE_CONFIGURATION] CLEAN',
  MODULE_CONFIGURATION_UPDATE: '[MODULE_CONFIGURATION] UPDATE',
  MODULE_CONFIGURATION_DELETE: '[MODULE_CONFIGURATION] DELETE',
  MODULE_CONFIGURATION_START_REGISTER: '[MODULE_CONFIGURATION] START REGISTER',
  MODULE_CONFIGURATION_START_SEARCH: '[MODULE_CONFIGURATION] START SEARCH',
  MODULE_CONFIGURATION_START_SEARCH_PAGINATED: '[MODULE_CONFIGURATION] START SEARCH PAGINATED',
  MODULE_CONFIGURATION_SET_SEARCH_TEXT: '[MODULE_CONFIGURATION] SET SEARCH TEXT',
  MODULE_CONFIGURATION_START_LOADING_ALL: '[MODULE_CONFIGURATION] START LOADING ALL',

  //SEARCH HISTORY
  SET_PREVIOUS_SEARCH_PARAMS: '[SEARCH] SET PREVIOUS SEARCH PARAMS',
  SET_CURRENT_SEARCH_PARAMS: '[SEARCH] SET CURRENT SEARCH PARAMS',
  CLEAN_SEARCH_PARAMS: '[SEARCH] CLEAN SEARCH PARAMS',
  CLEAN_SEARCH_PARAMS_NO_MODULE: '[SEARCH] CLEAN SEARCH PARAMS NO MODULE',

  USER_INTEREST_START_LOADING_PAGINATED: '[USER_INTEREST] START LOADING PAGINATED',
  USER_INTEREST_SELECT: '[USER_INTEREST] SELECT',
  USER_INTEREST_CLEAN: '[USER_INTEREST] CLEAN',
  USER_INTEREST_SET_LOADING: '[USER_INTEREST] SET LOADING',

  SUPPORT_FORM_SET_LOADING: '[SUPPORT_FORM] SET LOADING',
  SUPPORT_FORM_SET_LIST: '[SUPPORT_FORM] SET LIST',
  SUPPORT_FORM_SET_SELECTED: '[SUPPORT_FORM] SET SELECTED',
  SUPPORT_FORM_CLEAN: '[SUPPORT_FORM] CLEAN',

  HOME_CONTENT_SET_LOADING: '[HOME_CONTENT] SET LOADING',
  HOME_CONTENT_SET_TYPES: '[HOME_CONTENT] SET TYPES',
  HOME_CONTENT_SET_ITEMS: '[HOME_CONTENT] SET ITEMS',

  SPECIALIST_GUIDE_SET_LOADING: '[SPECIALIST_GUIDE] SET LOADING',
  SPECIALIST_GUIDE_SET_OPTIONS: '[SPECIALIST_GUIDE] SET OPTIONS',
  SPECIALIST_GUIDE_SET_LIST: '[SPECIALIST_GUIDE] SET LIST',

  SEARCH_KEY_TERM_SET_LOADING: '[SEARCH_KEY_TERM] SET LOADING',
  SEARCH_KEY_TERM_SET_ROWS: '[SEARCH_KEY_TERM] SET ROWS',
  SEARCH_KEY_TERM_SET_FIELDS: '[SEARCH_KEY_TERM] SET FIELDS',
  SEARCH_KEY_TERM_SET_SAVING: '[SEARCH_KEY_TERM] SET SAVING',
  SEARCH_KEY_TERM_SET_SELECTED: '[SEARCH_KEY_TERM] SET SELECTED',

}